export default [
  'ABABA',
  'ABACI',
  'ABACÁ',
  'ABACÉ',
  'ABADA',
  'ABADE',
  'ABADO',
  'ABAFA',
  'ABAFE',
  'ABAFO',
  'ABAIS',
  'ABAJU',
  'ABAJÁ',
  'ABALA',
  'ABALE',
  'ABALO',
  'ABAMA',
  'ABANA',
  'ABANE',
  'ABANO',
  'ABARÁ',
  'ABARÉ',
  'ABATA',
  'ABATE',
  'ABATI',
  'ABATO',
  'ABAVI',
  'ABDAL',
  'ABEBÉ',
  'ABECÊ',
  'ABEDÊ',
  'ABELA',
  'ABETA',
  'ABETE',
  'ABETO',
  'ABIAS',
  'ABIBE',
  'ABISA',
  'ABITA',
  'ABITO',
  'ABIÃO',
  'ABOBÓ',
  'ABOCA',
  'ABOFÉ',
  'ABOIO',
  'ABOLA',
  'ABOLE',
  'ABOLI',
  'ABONA',
  'ABONE',
  'ABONO',
  'ABRAM',
  'ABRAS',
  'ABREM',
  'ABRES',
  'ABREU',
  'ABRIA',
  'ABRIL',
  'ABRIR',
  'ABRIS',
  'ABRIU',
  'ABUDO',
  'ABULO',
  'ABUNA',
  'ABUSA',
  'ABUSE',
  'ABUSO',
  'ACABA',
  'ACABE',
  'ACABO',
  'ACAIA',
  'ACAJU',
  'ACAJÁ',
  'ACAMA',
  'ACANA',
  'ACAPU',
  'ACARI',
  'ACARÁ',
  'ACASO',
  'ACATA',
  'ACATE',
  'ACATO',
  'ACAUÃ',
  'ACAÇÁ',
  'ACECA',
  'ACELO',
  'ACENA',
  'ACENE',
  'ACENO',
  'ACERO',
  'ACESA',
  'ACESO',
  'ACETO',
  'ACHAI',
  'ACHAM',
  'ACHAR',
  'ACHAS',
  'ACHEI',
  'ACHEM',
  'ACHES',
  'ACHOA',
  'ACHOU',
  'ACICA',
  'ACILA',
  'ACILO',
  'ACIMA',
  'ACISO',
  'ACNES',
  'ACOAR',
  'ACODE',
  'ACOLI',
  'ACOLÁ',
  'ACONÁ',
  'ACRAL',
  'ACRES',
  'ACTEL',
  'ACUAM',
  'ACUAR',
  'ACUDI',
  'ACUDO',
  'ACUME',
  'ACUMÃ',
  'ACUNA',
  'ACUOU',
  'ACURI',
  'ACUSA',
  'ACUSE',
  'ACUSO',
  'ACUTA',
  'ACUTI',
  'ADAGA',
  'ADAGE',
  'ADAIL',
  'ADAMO',
  'ADAÍS',
  'ADEBÁ',
  'ADEGA',
  'ADEJO',
  'ADELA',
  'ADELE',
  'ADELO',
  'ADEMA',
  'ADERE',
  'ADERI',
  'ADESO',
  'ADEUS',
  'ADIAM',
  'ADIAR',
  'ADIAS',
  'ADIBE',
  'ADICA',
  'ADIDA',
  'ADIDO',
  'ADIEI',
  'ADIEM',
  'ADIES',
  'ADIMO',
  'ADINO',
  'ADIOU',
  'ADIRA',
  'ADIRO',
  'ADITA',
  'ADITE',
  'ADITO',
  'ADOBA',
  'ADOBE',
  'ADOBO',
  'ADOCE',
  'ADOLO',
  'ADORA',
  'ADORE',
  'ADORO',
  'ADOTA',
  'ADOTE',
  'ADOTO',
  'ADOÇA',
  'ADOÇO',
  'ADQUI',
  'ADUBA',
  'ADUBE',
  'ADUBO',
  'ADUFA',
  'ADUFE',
  'ADUFO',
  'ADULA',
  'ADULE',
  'ADULO',
  'ADVIR',
  'ADVÉM',
  'AFAGA',
  'AFAGO',
  'AFALA',
  'AFANA',
  'AFANO',
  'AFEAR',
  'AFEGÃ',
  'AFERE',
  'AFERI',
  'AFETA',
  'AFETE',
  'AFETO',
  'AFIAL',
  'AFIAM',
  'AFIAR',
  'AFIAS',
  'AFIEI',
  'AFIEM',
  'AFINA',
  'AFINE',
  'AFINO',
  'AFINS',
  'AFIOU',
  'AFIRA',
  'AFIRO',
  'AFIXA',
  'AFIXE',
  'AFIXO',
  'AFLAR',
  'AFLUA',
  'AFLUI',
  'AFOBA',
  'AFOBE',
  'AFOBO',
  'AFOFA',
  'AFOFE',
  'AFOFO',
  'AFOGA',
  'AFOGO',
  'AFONO',
  'AFORA',
  'AFORO',
  'AFOXÉ',
  'AFROS',
  'AFTAS',
  'AGABE',
  'AGACÉ',
  'AGADÁ',
  'AGAMA',
  'AGAME',
  'AGAMI',
  'AGARA',
  'AGAVE',
  'AGEIA',
  'AGIAM',
  'AGIAS',
  'AGIDO',
  'AGINA',
  'AGIRA',
  'AGITA',
  'AGITE',
  'AGITO',
  'AGLIA',
  'AGMAR',
  'AGOGE',
  'AGOGÔ',
  'AGORA',
  'AGORI',
  'AGRAR',
  'AGRAZ',
  'AGROR',
  'AGUAR',
  'AGUAÍ',
  'AGUCE',
  'AGUDA',
  'AGUDE',
  'AGUDO',
  'AGUEI',
  'AGUEM',
  'AGUES',
  'AGUOU',
  'AGUTI',
  'AGUÇA',
  'AGUÇO',
  'AIAIA',
  'AIALA',
  'AIARÁ',
  'AINDA',
  'AINSA',
  'AIOLA',
  'AIPIM',
  'AIPOS',
  'AIRES',
  'AIRÃO',
  'AJAJA',
  'AJAPÁ',
  'AJARÁ',
  'AJAUA',
  'AJUDA',
  'AJUDE',
  'AJUDO',
  'AJUGA',
  'AJURI',
  'AJURU',
  'ALABÁ',
  'ALABÊ',
  'ALADA',
  'ALADO',
  'ALAGA',
  'ALAGO',
  'ALAIM',
  'ALALÁ',
  'ALANO',
  'ALARA',
  'ALBIS',
  'ALBOR',
  'ALBÓI',
  'ALCEI',
  'ALCEM',
  'ALCES',
  'ALCIS',
  'ALDEÃ',
  'ALDOL',
  'ALEFE',
  'ALEGA',
  'ALEGO',
  'ALEIA',
  'ALEJÁ',
  'ALELI',
  'ALELO',
  'ALEMÃ',
  'ALENA',
  'ALEPO',
  'ALETA',
  'ALETO',
  'ALEVÁ',
  'ALFAR',
  'ALFAS',
  'ALFIL',
  'ALFIM',
  'ALFOZ',
  'ALGAL',
  'ALGAR',
  'ALGAS',
  'ALGER',
  'ALGIA',
  'ALGOL',
  'ALGOR',
  'ALGOZ',
  'ALGUM',
  'ALHAR',
  'ALHAS',
  'ALHEO',
  'ALHEÁ',
  'ALHOS',
  'ALIAM',
  'ALIAR',
  'ALIEI',
  'ALIEM',
  'ALIES',
  'ALIJA',
  'ALIJE',
  'ALIJO',
  'ALILA',
  'ALILO',
  'ALIME',
  'ALIOU',
  'ALISA',
  'ALISE',
  'ALISO',
  'ALITA',
  'ALIÁS',
  'ALMAS',
  'ALOCA',
  'ALOCO',
  'ALOJA',
  'ALOJE',
  'ALOJO',
  'ALOÉS',
  'ALPES',
  'ALTAR',
  'ALTAS',
  'ALTER',
  'ALTEÁ',
  'ALTIM',
  'ALTOR',
  'ALTOS',
  'ALUAR',
  'ALUCO',
  'ALUDA',
  'ALUDE',
  'ALUDI',
  'ALUDO',
  'ALUFÁ',
  'ALUGA',
  'ALUGO',
  'ALUIR',
  'ALUJÁ',
  'ALUME',
  'ALUNA',
  'ALUNE',
  'ALUNO',
  'ALVAR',
  'ALVAS',
  'ALVOR',
  'ALVOS',
  'ALVÃO',
  'ALÇAM',
  'ALÇAR',
  'ALÇAS',
  'ALÇOU',
  'AMACA',
  'AMACI',
  'AMADA',
  'AMADO',
  'AMADU',
  'AMAGA',
  'AMAIS',
  'AMALÁ',
  'AMAME',
  'AMAMO',
  'AMANÁ',
  'AMAPÁ',
  'AMARA',
  'AMARO',
  'AMATO',
  'AMAVA',
  'AMBAS',
  'AMBIA',
  'AMBOM',
  'AMBOS',
  'AMBOÁ',
  'AMBRE',
  'AMBÃO',
  'AMEBA',
  'AMEIA',
  'AMEIS',
  'AMELA',
  'AMELO',
  'AMEMO',
  'AMENA',
  'AMENO',
  'AMEÇA',
  'AMIAL',
  'AMIBA',
  'AMIDA',
  'AMIDO',
  'AMIGA',
  'AMIGO',
  'AMILA',
  'AMILO',
  'AMIMA',
  'AMINA',
  'AMINO',
  'AMITO',
  'AMOLA',
  'AMOLE',
  'AMOLO',
  'AMORA',
  'AMORÉ',
  'AMPLA',
  'AMPLO',
  'AMUAR',
  'AMUOS',
  'AMURA',
  'AMURI',
  'ANACO',
  'ANACÃ',
  'ANACÉ',
  'ANAFE',
  'ANAIS',
  'ANAIÁ',
  'ANAJÁ',
  'ANAME',
  'ANANI',
  'ANANÁ',
  'ANATA',
  'ANATI',
  'ANATO',
  'ANAUÊ',
  'ANCAS',
  'ANCHO',
  'ANCIÃ',
  'ANDAI',
  'ANDAM',
  'ANDAR',
  'ANDAS',
  'ANDEI',
  'ANDEM',
  'ANDES',
  'ANDIM',
  'ANDOA',
  'ANDOR',
  'ANDOU',
  'ANEEL',
  'ANEJO',
  'ANELA',
  'ANELE',
  'ANELO',
  'ANEMA',
  'ANESA',
  'ANETE',
  'ANETO',
  'ANEXA',
  'ANEXE',
  'ANEXO',
  'ANGEL',
  'ANGLA',
  'ANGLO',
  'ANGOR',
  'ANGRA',
  'ANIBA',
  'ANIMA',
  'ANIME',
  'ANIMI',
  'ANINA',
  'ANISO',
  'ANITA',
  'ANIÃO',
  'ANJOS',
  'ANJÃO',
  'ANOJO',
  'ANONA',
  'ANORI',
  'ANOSO',
  'ANOTA',
  'ANOTE',
  'ANOTO',
  'ANSAR',
  'ANTAL',
  'ANTAR',
  'ANTAS',
  'ANTES',
  'ANTIA',
  'ANTRO',
  'ANTÃO',
  'ANUAL',
  'ANUAS',
  'ANUEM',
  'ANUIR',
  'ANUIU',
  'ANUIÁ',
  'ANULA',
  'ANULE',
  'ANULO',
  'ANURO',
  'ANZOL',
  'ANÉIS',
  'ANÕES',
  'AONDE',
  'AOQUI',
  'AORTA',
  'AOÍTA',
  'APAGA',
  'APAGO',
  'APAMÁ',
  'APANA',
  'APAPÁ',
  'APARA',
  'APARE',
  'APARO',
  'APEAR',
  'APEEI',
  'APEGA',
  'APEGO',
  'APEIA',
  'APEIE',
  'APEIO',
  'APELA',
  'APELE',
  'APELO',
  'APENA',
  'APENE',
  'APEOU',
  'APERO',
  'APIOL',
  'APITA',
  'APITE',
  'APITO',
  'APODO',
  'APOIA',
  'APOIE',
  'APOIO',
  'APOJO',
  'APOLO',
  'APOTA',
  'APRAZ',
  'APREÁ',
  'APTAR',
  'APTAS',
  'APTOS',
  'APUPO',
  'APURA',
  'APURE',
  'APURO',
  'AQUEU',
  'AQUÉM',
  'ARABI',
  'ARABÁ',
  'ARACI',
  'ARACU',
  'ARADA',
  'ARADO',
  'ARAIS',
  'ARAIÁ',
  'ARAME',
  'ARAMO',
  'ARAMÃ',
  'ARANÃ',
  'ARARA',
  'ARARI',
  'ARATU',
  'ARATÁ',
  'ARAVA',
  'ARAXÁ',
  'ARAZA',
  'ARAÇÁ',
  'ARCAM',
  'ARCAR',
  'ARCAS',
  'ARCAZ',
  'ARCHA',
  'ARCOS',
  'ARCOU',
  'ARDAM',
  'ARDAS',
  'ARDEM',
  'ARDER',
  'ARDES',
  'ARDEU',
  'ARDIA',
  'ARDIL',
  'ARDIS',
  'ARDOR',
  'ARDRA',
  'AREAL',
  'AREAR',
  'ARECA',
  'AREDÊ',
  'AREIA',
  'AREIO',
  'AREIS',
  'AREJA',
  'AREJE',
  'AREJO',
  'AREMO',
  'ARENA',
  'ARERÊ',
  'AREÃO',
  'ARFAM',
  'ARFAR',
  'ARFEI',
  'ARFOU',
  'ARGAS',
  'ARGEL',
  'ARGOL',
  'ARGOS',
  'ARGUA',
  'ARGUE',
  'ARGUI',
  'ARGUO',
  'ARGÃO',
  'ARIAR',
  'ARIBÉ',
  'ARICÁ',
  'ARICÓ',
  'ARIGÓ',
  'ARILA',
  'ARILO',
  'ARIMÃ',
  'ARINÁ',
  'ARIPO',
  'ARIRI',
  'ARITO',
  'ARITÁ',
  'ARMAI',
  'ARMAM',
  'ARMAR',
  'ARMAS',
  'ARMEI',
  'ARMEM',
  'ARMES',
  'ARMIM',
  'ARMOU',
  'ARMÃO',
  'ARNAL',
  'ARNÊS',
  'AROLA',
  'AROMA',
  'AROTO',
  'ARPOA',
  'ARPÃO',
  'ARPÉU',
  'ARQUE',
  'ARQUI',
  'ARRAS',
  'ARREÁ',
  'ARRIA',
  'ARRIE',
  'ARRIO',
  'ARROZ',
  'ARRUÁ',
  'ARTES',
  'ARTRO',
  'ARUCA',
  'ARUJO',
  'ARUMÃ',
  'ARUPA',
  'ARUTO',
  'ARVAL',
  'ARÇÃO',
  'ASADA',
  'ASADO',
  'ASANA',
  'ASASE',
  'ASCAL',
  'ASCII',
  'ASILA',
  'ASILE',
  'ASILO',
  'ASNAL',
  'ASNOS',
  'ASPAR',
  'ASPAS',
  'ASPES',
  'ASSAI',
  'ASSAM',
  'ASSAR',
  'ASSAS',
  'ASSAZ',
  'ASSEI',
  'ASSEM',
  'ASSES',
  'ASSIM',
  'ASSOA',
  'ASSOE',
  'ASSOO',
  'ASSOU',
  'ASSUÃ',
  'ASTRE',
  'ASTRO',
  'ASURA',
  'ATACA',
  'ATACO',
  'ATADA',
  'ATADO',
  'ATAIS',
  'ATALÁ',
  'ATAMÃ',
  'ATANA',
  'ATARA',
  'ATARÊ',
  'ATAVA',
  'ATEAR',
  'ATEEI',
  'ATEIA',
  'ATEIE',
  'ATEIO',
  'ATELA',
  'ATEMO',
  'ATEOU',
  'ATERÁ',
  'ATEUS',
  'ATEVE',
  'ATICE',
  'ATICO',
  'ATIDO',
  'ATINA',
  'ATINE',
  'ATINO',
  'ATIRA',
  'ATIRE',
  'ATIRO',
  'ATIVA',
  'ATIVE',
  'ATIVO',
  'ATIÇA',
  'ATLAS',
  'ATOAR',
  'ATOBÁ',
  'ATOLA',
  'ATOLE',
  'ATOLO',
  'ATORA',
  'ATOTÔ',
  'ATRAI',
  'ATRIL',
  'ATRIZ',
  'ATROZ',
  'ATRÁS',
  'ATUAI',
  'ATUAL',
  'ATUAM',
  'ATUAR',
  'ATUAS',
  'ATUEI',
  'ATUEM',
  'ATUES',
  'ATUNS',
  'ATUOU',
  'ATURA',
  'ATURE',
  'ATURO',
  'ATÉNS',
  'AUATI',
  'AUDAZ',
  'AUGAR',
  'AUGES',
  'AULAS',
  'AUNAR',
  'AURAS',
  'AURIR',
  'AUTOR',
  'AUTOS',
  'AUTUA',
  'AUTUE',
  'AVAIS',
  'AVANO',
  'AVARA',
  'AVARI',
  'AVARO',
  'AVARÉ',
  'AVATI',
  'AVEIA',
  'AVELÃ',
  'AVENA',
  'AVEUS',
  'AVIAM',
  'AVIAR',
  'AVIAS',
  'AVIEI',
  'AVIEM',
  'AVIER',
  'AVIES',
  'AVIOS',
  'AVIOU',
  'AVIRÁ',
  'AVISA',
  'AVISE',
  'AVISO',
  'AVITO',
  'AVIUM',
  'AVIVA',
  'AVIVE',
  'AVIVO',
  'AVIÃO',
  'AVOAR',
  'AXEXÊ',
  'AXIAL',
  'AXILA',
  'AXOXÔ',
  'AZADO',
  'AZARA',
  'AZARE',
  'AZARO',
  'AZEDA',
  'AZEDE',
  'AZEDO',
  'AZERI',
  'AZIAR',
  'AZIAS',
  'AZIDA',
  'AZOLA',
  'AZOTE',
  'AZOTO',
  'AZUIS',
  'AZULA',
  'AZULE',
  'AZULO',
  'AÇACU',
  'AÇALÁ',
  'AÇAME',
  'AÇAMO',
  'AÇOCA',
  'AÇUDA',
  'AÇUDE',
  'AÇÕES',
  'AÉREA',
  'AÉREO',
  'AÚSTE',
  'BAALI',
  'BABAI',
  'BABAL',
  'BABAM',
  'BABAR',
  'BABAS',
  'BABAU',
  'BABEI',
  'BABEL',
  'BABEM',
  'BABER',
  'BABES',
  'BABIÁ',
  'BABLE',
  'BABOU',
  'BABÃO',
  'BACAL',
  'BACAR',
  'BACEN',
  'BACHI',
  'BACIA',
  'BACIO',
  'BACON',
  'BACTA',
  'BACÃO',
  'BADAL',
  'BADIO',
  'BAENÃ',
  'BAETA',
  'BAFAR',
  'BAFIO',
  'BAFOS',
  'BAGAR',
  'BAGAS',
  'BAGEM',
  'BAGOS',
  'BAGRE',
  'BAGUE',
  'BAGUÁ',
  'BAHIA',
  'BAIAR',
  'BAIAS',
  'BAIBE',
  'BAILA',
  'BAILE',
  'BAILO',
  'BAIOS',
  'BAIRU',
  'BAITA',
  'BAITE',
  'BAIXA',
  'BAIXE',
  'BAIXO',
  'BAIÃO',
  'BAJAR',
  'BALAM',
  'BALAR',
  'BALAS',
  'BALAU',
  'BALBO',
  'BALDA',
  'BALDE',
  'BALDO',
  'BALEM',
  'BALES',
  'BALEÃ',
  'BALHA',
  'BALHO',
  'BALIA',
  'BALIM',
  'BALIO',
  'BALIR',
  'BALIS',
  'BALIU',
  'BALSA',
  'BALSO',
  'BALTA',
  'BALÃO',
  'BALÇA',
  'BAMBA',
  'BAMBO',
  'BAMBU',
  'BAMBÊ',
  'BANAL',
  'BANCA',
  'BANCO',
  'BANDA',
  'BANDO',
  'BANEM',
  'BANES',
  'BANGA',
  'BANGO',
  'BANGU',
  'BANHA',
  'BANHE',
  'BANHO',
  'BANIR',
  'BANIU',
  'BANJA',
  'BANJO',
  'BANTO',
  'BANTU',
  'BANTÁ',
  'BANZA',
  'BANZO',
  'BANZÉ',
  'BAOBÁ',
  'BAQUE',
  'BARBA',
  'BARBI',
  'BARBO',
  'BARCO',
  'BARDA',
  'BARDO',
  'BARES',
  'BARGA',
  'BARIA',
  'BARIL',
  'BARIS',
  'BAROA',
  'BARRA',
  'BARRO',
  'BARRÉ',
  'BARSI',
  'BARÃO',
  'BARÇA',
  'BARÉM',
  'BASAL',
  'BASAR',
  'BASCO',
  'BASES',
  'BASEÁ',
  'BASIC',
  'BASSO',
  'BASSÊ',
  'BASTA',
  'BASTE',
  'BASTO',
  'BATAM',
  'BATAS',
  'BATCH',
  'BATEI',
  'BATEL',
  'BATEM',
  'BATER',
  'BATES',
  'BATEU',
  'BATIA',
  'BATOM',
  'BATOS',
  'BATÃO',
  'BAUMA',
  'BAURU',
  'BAXIM',
  'BAZAR',
  'BAÇOS',
  'BAÍRA',
  'BEABÁ',
  'BEATA',
  'BEATO',
  'BEBAM',
  'BEBAS',
  'BEBEI',
  'BEBEM',
  'BEBER',
  'BEBEU',
  'BEBIA',
  'BEBUM',
  'BEBÊS',
  'BECAS',
  'BECHE',
  'BECOS',
  'BEDEL',
  'BEDUM',
  'BEGUE',
  'BEGUM',
  'BEIJA',
  'BEIJE',
  'BEIJI',
  'BEIJO',
  'BEIJU',
  'BEIRA',
  'BEIRE',
  'BEIRO',
  'BEIRU',
  'BEIÇA',
  'BEIÇO',
  'BELAS',
  'BELAZ',
  'BELFO',
  'BELGA',
  'BELHO',
  'BELIZ',
  'BELOS',
  'BELÃO',
  'BEMBA',
  'BEMBÉ',
  'BEMOL',
  'BENCO',
  'BENDA',
  'BENDI',
  'BENDÉ',
  'BENGE',
  'BENGO',
  'BENHÃ',
  'BENIM',
  'BENTA',
  'BENTO',
  'BENZA',
  'BENZE',
  'BENZI',
  'BENZO',
  'BENÇA',
  'BEQUE',
  'BERBA',
  'BERBE',
  'BERDA',
  'BERGO',
  'BERMA',
  'BERNA',
  'BERNE',
  'BERNO',
  'BEROÉ',
  'BERRA',
  'BERRE',
  'BERRO',
  'BERTA',
  'BERÇA',
  'BERÇO',
  'BESSI',
  'BESSO',
  'BESTA',
  'BETAR',
  'BETLE',
  'BETÃO',
  'BIABA',
  'BIANA',
  'BIATA',
  'BIBES',
  'BIBIÁ',
  'BIBLÁ',
  'BIBRA',
  'BICAL',
  'BICAM',
  'BICAR',
  'BICAS',
  'BICHA',
  'BICHO',
  'BICOS',
  'BICOU',
  'BICÃO',
  'BIDÃO',
  'BIELA',
  'BIENE',
  'BIENO',
  'BIFAR',
  'BIGAS',
  'BIGUE',
  'BIGUÁ',
  'BIJOU',
  'BILAR',
  'BILHA',
  'BILHÓ',
  'BILRO',
  'BIMBA',
  'BIMBO',
  'BINAR',
  'BINDA',
  'BINDE',
  'BINGA',
  'BINGO',
  'BINHA',
  'BIOCO',
  'BIOMA',
  'BIOSE',
  'BIOTA',
  'BIPAR',
  'BIQUE',
  'BIRRA',
  'BIRRE',
  'BIRRO',
  'BISAR',
  'BISCA',
  'BISCO',
  'BISEL',
  'BISGA',
  'BISPO',
  'BISSO',
  'BISÃO',
  'BITAR',
  'BLASÉ',
  'BLEFA',
  'BLEFE',
  'BLEFO',
  'BLITZ',
  'BLOCO',
  'BLOGS',
  'BLUES',
  'BLUSA',
  'BLUSH',
  'BNDES',
  'BOANA',
  'BOANE',
  'BOARI',
  'BOATE',
  'BOATO',
  'BOAVA',
  'BOBAR',
  'BOBAS',
  'BOBES',
  'BOBOS',
  'BOBÃO',
  'BOCAL',
  'BOCAR',
  'BOCAS',
  'BOCEL',
  'BOCHA',
  'BOCHE',
  'BOCÃO',
  'BODAR',
  'BODAS',
  'BODES',
  'BODUM',
  'BOFES',
  'BOGUE',
  'BOIAM',
  'BOIAR',
  'BOIAS',
  'BOIEI',
  'BOIEM',
  'BOINA',
  'BOIOU',
  'BOITA',
  'BOITE',
  'BOIÃO',
  'BOIÇA',
  'BOJÃO',
  'BOLAM',
  'BOLAR',
  'BOLAS',
  'BOLBO',
  'BOLCO',
  'BOLDO',
  'BOLEI',
  'BOLEM',
  'BOLES',
  'BOLHA',
  'BOLHÓ',
  'BOLIM',
  'BOLOR',
  'BOLOS',
  'BOLOU',
  'BOLSA',
  'BOLSO',
  'BOLÃO',
  'BOMBA',
  'BOMBO',
  'BONDA',
  'BONDE',
  'BONDI',
  'BONGÔ',
  'BONHO',
  'BONZE',
  'BONZO',
  'BONÉS',
  'BOORÁ',
  'BOQUE',
  'BORCO',
  'BORDA',
  'BORDE',
  'BORDO',
  'BORGA',
  'BORLA',
  'BORNE',
  'BORNO',
  'BOROA',
  'BOROS',
  'BORRA',
  'BORRE',
  'BORRO',
  'BORÁS',
  'BOSCA',
  'BOSSA',
  'BOSTA',
  'BOSÃO',
  'BOTAL',
  'BOTAM',
  'BOTAR',
  'BOTAS',
  'BOTEI',
  'BOTEM',
  'BOTES',
  'BOTIM',
  'BOTOS',
  'BOTOU',
  'BOTÃO',
  'BOUBA',
  'BOUDA',
  'BOUÇA',
  'BOUÇO',
  'BRABA',
  'BRABO',
  'BRADA',
  'BRADE',
  'BRADO',
  'BRAGA',
  'BRAJÁ',
  'BRAMA',
  'BRAME',
  'BRAMI',
  'BRAMO',
  'BRASA',
  'BRAVA',
  'BRAVO',
  'BRAÇA',
  'BRAÇO',
  'BREAK',
  'BREAL',
  'BRECA',
  'BRECO',
  'BREDO',
  'BREGA',
  'BREIA',
  'BREIO',
  'BREJO',
  'BREMA',
  'BRETE',
  'BRETÃ',
  'BREVE',
  'BRIAL',
  'BRIBA',
  'BRICA',
  'BRIDA',
  'BRIGA',
  'BRIGO',
  'BRINS',
  'BRIOL',
  'BRIOS',
  'BRISA',
  'BRISE',
  'BRITA',
  'BRITO',
  'BRIVE',
  'BRIZA',
  'BROAS',
  'BROCA',
  'BROCO',
  'BRODA',
  'BROMA',
  'BROMO',
  'BROTA',
  'BROTE',
  'BROTO',
  'BROXA',
  'BROXO',
  'BRUAÁ',
  'BRUCO',
  'BRUMA',
  'BRUNA',
  'BRUNO',
  'BRUTA',
  'BRUTO',
  'BRUXA',
  'BRUXO',
  'BRÍON',
  'BUAVA',
  'BUBÃO',
  'BUCAL',
  'BUCHA',
  'BUCHO',
  'BUCHU',
  'BUCIM',
  'BUCLE',
  'BUFAM',
  'BUFAR',
  'BUFAS',
  'BUFEI',
  'BUFEM',
  'BUFES',
  'BUFOS',
  'BUFOU',
  'BUFÃO',
  'BUGIA',
  'BUGIO',
  'BUGLE',
  'BUGRA',
  'BUGRE',
  'BUJÃO',
  'BULAM',
  'BULAR',
  'BULAS',
  'BULBO',
  'BULDO',
  'BULES',
  'BULHA',
  'BULHO',
  'BULIA',
  'BULIR',
  'BULIU',
  'BUMBA',
  'BUMBO',
  'BUNDA',
  'BUNDO',
  'BUNGA',
  'BUNGO',
  'BUNHO',
  'BUQUÊ',
  'BURCA',
  'BURDO',
  'BUREL',
  'BURGO',
  'BURIL',
  'BURIS',
  'BURLA',
  'BURLE',
  'BURLO',
  'BURRA',
  'BURRO',
  'BURSA',
  'BUSCA',
  'BUSCO',
  'BUSSO',
  'BUSTO',
  'BUTAR',
  'BUTES',
  'BUTIL',
  'BUTIM',
  'BUTIÁ',
  'BUTUA',
  'BUXOS',
  'BUÍDO',
  'BÁCIS',
  'BÁDUR',
  'BÁRIO',
  'BÁSIO',
  'BÁSIS',
  'BÁTIS',
  'BÂMBI',
  'BÂNIA',
  'BÉLIS',
  'BÉTEL',
  'BÉTIS',
  'BÍLIA',
  'BÍLIS',
  'BÍTER',
  'BÓCIO',
  'BÓFIA',
  'BÓRAX',
  'BÓSON',
  'BÓXER',
  'BÔERS',
  'BÔNUS',
  'BÚTEO',
  'BÚTIO',
  'BÚZIO',
  'CAABA',
  'CAAMA',
  'CAAMI',
  'CAAPI',
  'CABAL',
  'CABAZ',
  'CABAÚ',
  'CABEI',
  'CABEM',
  'CABER',
  'CABES',
  'CABIA',
  'CABOS',
  'CABOZ',
  'CABRA',
  'CABRE',
  'CABRO',
  'CACAU',
  'CACEI',
  'CACEM',
  'CACES',
  'CACHA',
  'CACHE',
  'CACHO',
  'CACHU',
  'CACIM',
  'CACOS',
  'CACTO',
  'CADEÁ',
  'CADOZ',
  'CAETÉ',
  'CAFRE',
  'CAFTA',
  'CAFUA',
  'CAFUZ',
  'CAFÉS',
  'CAGAM',
  'CAGAR',
  'CAGAS',
  'CAGOU',
  'CAGUE',
  'CAGÃO',
  'CAIAM',
  'CAIAR',
  'CAIAS',
  'CAIBA',
  'CAIBO',
  'CAICÓ',
  'CAIDE',
  'CAIEM',
  'CAIOU',
  'CAIPA',
  'CAIRO',
  'CAIRÁ',
  'CAIRÉ',
  'CAITÉ',
  'CAIUÁ',
  'CAIXA',
  'CAIXE',
  'CAIÇÁ',
  'CAJUS',
  'CAJUÍ',
  'CALAI',
  'CALAM',
  'CALAR',
  'CALAS',
  'CALAU',
  'CALCE',
  'CALDA',
  'CALDO',
  'CALEI',
  'CALEM',
  'CALES',
  'CALFE',
  'CALHA',
  'CALHE',
  'CALHO',
  'CALIM',
  'CALMA',
  'CALMO',
  'CALOM',
  'CALOR',
  'CALOS',
  'CALOU',
  'CALTA',
  'CALUM',
  'CALVA',
  'CALVO',
  'CALÃO',
  'CALÇA',
  'CALÇO',
  'CAMAL',
  'CAMAS',
  'CAMAÁ',
  'CAMBA',
  'CAMBO',
  'CAMIM',
  'CAMPA',
  'CAMPO',
  'CAMPÉ',
  'CAMÃO',
  'CANAL',
  'CANAS',
  'CANCÃ',
  'CANDA',
  'CANDE',
  'CANDO',
  'CANEZ',
  'CANGA',
  'CANGO',
  'CANHA',
  'CANHO',
  'CANIL',
  'CANJA',
  'CANJE',
  'CANOA',
  'CANOS',
  'CANOÉ',
  'CANSA',
  'CANSE',
  'CANSO',
  'CANTA',
  'CANTE',
  'CANTO',
  'CANZÁ',
  'CAOBA',
  'CAPAI',
  'CAPAM',
  'CAPAR',
  'CAPAS',
  'CAPAZ',
  'CAPEI',
  'CAPEM',
  'CAPES',
  'CAPIM',
  'CAPIÁ',
  'CAPOU',
  'CAPRO',
  'CAPSA',
  'CAPTA',
  'CAPTE',
  'CAPTO',
  'CAPUT',
  'CAPUZ',
  'CAPÃO',
  'CAQUI',
  'CARAL',
  'CARAS',
  'CARDA',
  'CARDO',
  'CAREL',
  'CARGA',
  'CARGO',
  'CARIA',
  'CARIL',
  'CARIO',
  'CARIZ',
  'CARMA',
  'CARME',
  'CARNE',
  'CAROS',
  'CAROÁ',
  'CAROÉ',
  'CARPA',
  'CARPE',
  'CARPI',
  'CARPO',
  'CARRI',
  'CARRO',
  'CARRÊ',
  'CARTA',
  'CARTE',
  'CARUÁ',
  'CARVA',
  'CARVI',
  'CARÃO',
  'CASAI',
  'CASAL',
  'CASAM',
  'CASAR',
  'CASAS',
  'CASBÁ',
  'CASCA',
  'CASCO',
  'CASEI',
  'CASEM',
  'CASES',
  'CASOS',
  'CASOU',
  'CASPA',
  'CASSA',
  'CASSE',
  'CASSO',
  'CASTA',
  'CASTI',
  'CASTO',
  'CASÃO',
  'CATAI',
  'CATAM',
  'CATAR',
  'CATAS',
  'CATAU',
  'CATEI',
  'CATEM',
  'CATES',
  'CATIM',
  'CATOU',
  'CATRE',
  'CATUR',
  'CATÃO',
  'CAUBI',
  'CAUDA',
  'CAUIM',
  'CAULE',
  'CAUMÃ',
  'CAUNA',
  'CAUPI',
  'CAURI',
  'CAURÉ',
  'CAUSA',
  'CAUSE',
  'CAUSO',
  'CAUTA',
  'CAUTO',
  'CAVAI',
  'CAVAM',
  'CAVAR',
  'CAVAS',
  'CAVEI',
  'CAVEM',
  'CAVES',
  'CAVOU',
  'CAVÃO',
  'CAXÃO',
  'CAÇAM',
  'CAÇAR',
  'CAÇAS',
  'CAÇOA',
  'CAÇOE',
  'CAÇOU',
  'CAÇUÁ',
  'CAÇÃO',
  'CAÍDA',
  'CAÍDO',
  'CCIII',
  'CEADO',
  'CEARÁ',
  'CEATA',
  'CEAVA',
  'CECAL',
  'CECÉM',
  'CEDAM',
  'CEDAS',
  'CEDEI',
  'CEDEM',
  'CEDER',
  'CEDES',
  'CEDEU',
  'CEDIA',
  'CEDRO',
  'CEFEU',
  'CEGAI',
  'CEGAM',
  'CEGAR',
  'CEGAS',
  'CEGOS',
  'CEGOU',
  'CEGUE',
  'CEIAM',
  'CEIAS',
  'CEIBA',
  'CEIBO',
  'CEIFA',
  'CEIFE',
  'CEIFO',
  'CEIRA',
  'CEITA',
  'CEIVA',
  'CEIVE',
  'CELAS',
  'CELGA',
  'CELHA',
  'CELSO',
  'CELTA',
  'CENAS',
  'CENHO',
  'CENSO',
  'CENTO',
  'CERAR',
  'CERAS',
  'CERCA',
  'CERCE',
  'CERCO',
  'CERDA',
  'CERDO',
  'CERES',
  'CERNA',
  'CERNE',
  'CEROL',
  'CERRA',
  'CERRE',
  'CERRO',
  'CERTA',
  'CERTO',
  'CERVA',
  'CERVO',
  'CESSA',
  'CESSE',
  'CESSO',
  'CESTA',
  'CESTO',
  'CETAL',
  'CETEF',
  'CETIL',
  'CETIM',
  'CETOL',
  'CETRA',
  'CETRO',
  'CEVAR',
  'CEVÃO',
  'CEÇÃO',
  'CHABU',
  'CHACO',
  'CHADA',
  'CHAGA',
  'CHAIÁ',
  'CHAJÁ',
  'CHALO',
  'CHALÉ',
  'CHAMA',
  'CHAME',
  'CHAMO',
  'CHANA',
  'CHAPA',
  'CHAPE',
  'CHAPO',
  'CHARA',
  'CHARO',
  'CHARU',
  'CHATA',
  'CHATO',
  'CHATÉ',
  'CHAUÁ',
  'CHAVE',
  'CHAVO',
  'CHAÇA',
  'CHECA',
  'CHECO',
  'CHEDA',
  'CHEDE',
  'CHEFA',
  'CHEFE',
  'CHEGA',
  'CHEGO',
  'CHEIA',
  'CHEIO',
  'CHELA',
  'CHENA',
  'CHESF',
  'CHETA',
  'CHETO',
  'CHIAM',
  'CHIAR',
  'CHIAS',
  'CHIBA',
  'CHIBO',
  'CHIBÉ',
  'CHICA',
  'CHICO',
  'CHIEI',
  'CHIEM',
  'CHIES',
  'CHILA',
  'CHILE',
  'CHILI',
  'CHILO',
  'CHIMA',
  'CHIMU',
  'CHINA',
  'CHINÓ',
  'CHIOU',
  'CHIPO',
  'CHIRA',
  'CHIRU',
  'CHITA',
  'CHIÃO',
  'CHOCA',
  'CHOCO',
  'CHOGÓ',
  'CHOLA',
  'CHOLE',
  'CHOLO',
  'CHONA',
  'CHONÉ',
  'CHOPA',
  'CHOPE',
  'CHOPI',
  'CHORA',
  'CHORE',
  'CHORO',
  'CHOTA',
  'CHOTO',
  'CHOVA',
  'CHOVE',
  'CHOVI',
  'CHOVO',
  'CHUCA',
  'CHUFA',
  'CHULA',
  'CHULO',
  'CHULÉ',
  'CHUNA',
  'CHUPA',
  'CHUPE',
  'CHUPO',
  'CHUTA',
  'CHUTE',
  'CHUTO',
  'CHUVA',
  'CHUÇO',
  'CHÃOS',
  'CIADO',
  'CIANO',
  'CIBER',
  'CIBUM',
  'CICAS',
  'CICIA',
  'CICIO',
  'CICLO',
  'CIDRA',
  'CIDRÓ',
  'CIENA',
  'CIESE',
  'CIFRA',
  'CIFRE',
  'CIFRO',
  'CIGNO',
  'CILHA',
  'CIMBA',
  'CIMOL',
  'CINCA',
  'CINCO',
  'CINDA',
  'CINDE',
  'CINDI',
  'CINDO',
  'CINGE',
  'CINGI',
  'CINJA',
  'CINJO',
  'CINTA',
  'CINTO',
  'CINZA',
  'CIOBA',
  'CIONA',
  'CIOSA',
  'CIOSO',
  'CIPÓS',
  'CIRCO',
  'CIRRO',
  'CIRSO',
  'CIRÃO',
  'CISAR',
  'CISCA',
  'CISCO',
  'CISEL',
  'CISMA',
  'CISME',
  'CISMO',
  'CISNE',
  'CISTA',
  'CISTE',
  'CISTO',
  'CISÃO',
  'CITAM',
  'CITAR',
  'CITAS',
  'CITEI',
  'CITEM',
  'CITES',
  'CITOU',
  'CITRO',
  'CIVIL',
  'CIVIS',
  'CIÚME',
  'CLADE',
  'CLADO',
  'CLAMA',
  'CLAME',
  'CLAMO',
  'CLARA',
  'CLARO',
  'CLAVA',
  'CLAVE',
  'CLEAR',
  'CLENA',
  'CLERO',
  'CLICA',
  'CLIII',
  'CLIMA',
  'CLINA',
  'CLINE',
  'CLINO',
  'CLIPE',
  'CLIPS',
  'CLISE',
  'CLIVO',
  'CLONE',
  'CLONO',
  'CLORA',
  'CLORI',
  'CLORO',
  'CLOSE',
  'CLOWN',
  'CLUBE',
  'CLVII',
  'CLXII',
  'CLXIV',
  'CLXIX',
  'CLXVI',
  'CLXXI',
  'CLXXV',
  'CLXXX',
  'COADA',
  'COADO',
  'COAGE',
  'COAGI',
  'COAIS',
  'COAJA',
  'COALA',
  'COAMO',
  'COARA',
  'COATI',
  'COATO',
  'COATÁ',
  'COAVA',
  'COAXA',
  'COAXO',
  'COBOL',
  'COBRA',
  'COBRE',
  'COBRI',
  'COBRO',
  'COBÓI',
  'COCAL',
  'COCEI',
  'COCEM',
  'COCES',
  'COCHA',
  'COCHE',
  'COCHO',
  'COCOA',
  'COCOS',
  'COCRE',
  'COCÃO',
  'CODAL',
  'COESA',
  'COESO',
  'COEVO',
  'COFIÓ',
  'COFRE',
  'COGER',
  'COIBI',
  'COICE',
  'COIFA',
  'COIMA',
  'COINÉ',
  'COIRA',
  'COIRO',
  'COISA',
  'COISO',
  'COITA',
  'COITO',
  'COITÉ',
  'COLAM',
  'COLAR',
  'COLAS',
  'COLCO',
  'COLEI',
  'COLEM',
  'COLES',
  'COLGA',
  'COLHA',
  'COLHE',
  'COLHI',
  'COLHO',
  'COLMA',
  'COLMO',
  'COLOR',
  'COLOS',
  'COLOU',
  'COLPO',
  'COLVÁ',
  'COLZA',
  'COMAM',
  'COMAS',
  'COMBA',
  'COMBE',
  'COMBI',
  'COMBO',
  'COMEI',
  'COMEM',
  'COMER',
  'COMES',
  'COMEU',
  'COMIA',
  'COMIL',
  'COMPÔ',
  'COMUA',
  'COMUM',
  'COMÃO',
  'CONAS',
  'CONCA',
  'CONDE',
  'CONDI',
  'CONDO',
  'CONES',
  'CONGA',
  'CONGO',
  'CONHA',
  'CONHO',
  'CONIN',
  'CONIO',
  'CONTA',
  'CONTE',
  'CONTO',
  'COPAL',
  'COPAR',
  'COPAS',
  'COPEL',
  'COPIE',
  'COPIO',
  'COPLA',
  'COPOS',
  'COPRA',
  'COPRO',
  'COPTA',
  'COPTO',
  'COQUE',
  'CORAL',
  'CORAM',
  'CORAR',
  'CORAS',
  'CORDA',
  'CORDO',
  'COREI',
  'COREM',
  'CORES',
  'COREU',
  'CORGA',
  'CORGO',
  'CORIA',
  'CORJA',
  'CORMO',
  'CORNA',
  'CORNE',
  'CORNO',
  'COROA',
  'COROE',
  'COROO',
  'COROS',
  'COROU',
  'CORPO',
  'CORRA',
  'CORRE',
  'CORRI',
  'CORRO',
  'CORSA',
  'CORSO',
  'CORTA',
  'CORTE',
  'CORTI',
  'CORTO',
  'CORVO',
  'CORÃO',
  'CORÇA',
  'CORÇO',
  'COSAM',
  'COSAS',
  'COSCA',
  'COSCO',
  'COSEM',
  'COSER',
  'COSES',
  'COSEU',
  'COSIA',
  'COSMO',
  'COSPE',
  'COSSA',
  'COSSI',
  'COSSO',
  'COSTA',
  'COSTO',
  'COTAI',
  'COTAM',
  'COTAR',
  'COTAS',
  'COTEI',
  'COTEM',
  'COTES',
  'COTIA',
  'COTIL',
  'COTIM',
  'COTIO',
  'COTOM',
  'COTOS',
  'COTOU',
  'COTRA',
  'COTÃO',
  'COUBE',
  'COUCE',
  'COUCO',
  'COUPÉ',
  'COURA',
  'COURO',
  'COUSA',
  'COUSO',
  'COUTO',
  'COUVE',
  'COVAL',
  'COVAS',
  'COVIL',
  'COVÃO',
  'COXAL',
  'COXAS',
  'COXIA',
  'COXIM',
  'COXOS',
  'COXÃO',
  'COZAM',
  'COZAS',
  'COZEI',
  'COZEM',
  'COZER',
  'COZES',
  'COZEU',
  'COZIA',
  'COÇAI',
  'COÇAM',
  'COÇAR',
  'COÇAS',
  'COÇOU',
  'COÍBA',
  'COÍBE',
  'COÍBO',
  'CRACA',
  'CRACK',
  'CRADA',
  'CRAPÔ',
  'CRASE',
  'CRATO',
  'CRAVA',
  'CRAVE',
  'CRAVO',
  'CRAWL',
  'CREDE',
  'CREDO',
  'CREEM',
  'CREIA',
  'CREIO',
  'CREMA',
  'CREME',
  'CREMO',
  'CRENA',
  'CREPE',
  'CRERA',
  'CRETA',
  'CRETE',
  'CRETO',
  'CREVE',
  'CRIAI',
  'CRIAM',
  'CRIAR',
  'CRIAS',
  'CRICA',
  'CRICO',
  'CRIDO',
  'CRIEI',
  'CRIEM',
  'CRIES',
  'CRIME',
  'CRINA',
  'CRINO',
  'CRIOU',
  'CRISE',
  'CRISO',
  'CRIVA',
  'CRIVE',
  'CRIVO',
  'CROCE',
  'CROCO',
  'CROMA',
  'CROME',
  'CROMO',
  'CRONO',
  'CROTA',
  'CROÇA',
  'CRUAS',
  'CRUDE',
  'CRUDO',
  'CRUEL',
  'CRUOR',
  'CRUPE',
  'CRUTO',
  'CRUZA',
  'CRUZE',
  'CRUZO',
  'CUADA',
  'CUBAL',
  'CUBAR',
  'CUBAS',
  'CUBOS',
  'CUBRA',
  'CUBRE',
  'CUBRO',
  'CUCAR',
  'CUCAS',
  'CUCHÊ',
  'CUCOS',
  'CUECA',
  'CUERA',
  'CUIAS',
  'CUIBA',
  'CUIDA',
  'CUIDE',
  'CUIDO',
  'CUITÁ',
  'CUITÉ',
  'CUITÓ',
  'CUJAS',
  'CUJOS',
  'CUJUS',
  'CULPA',
  'CULPE',
  'CULPO',
  'CULTA',
  'CULTO',
  'CUMBA',
  'CUMBE',
  'CUMBO',
  'CUMES',
  'CUMIM',
  'CUNCA',
  'CUNHA',
  'CUNHE',
  'CUNHO',
  'CUNTO',
  'CUPIM',
  'CUPOM',
  'CUPÃO',
  'CUQUE',
  'CURAI',
  'CURAM',
  'CURAR',
  'CURAS',
  'CURAU',
  'CURCA',
  'CURDO',
  'CUREI',
  'CUREM',
  'CURES',
  'CURIE',
  'CURIÓ',
  'CUROS',
  'CUROU',
  'CURRA',
  'CURRO',
  'CURRY',
  'CURSA',
  'CURSE',
  'CURSO',
  'CURTA',
  'CURTE',
  'CURTI',
  'CURTO',
  'CURUL',
  'CURUÁ',
  'CURVA',
  'CURVE',
  'CURVO',
  'CURÃO',
  'CUSCO',
  'CUSPA',
  'CUSPE',
  'CUSPI',
  'CUSPO',
  'CUSSO',
  'CUSTA',
  'CUSTE',
  'CUSTO',
  'CUTIA',
  'CUXIÚ',
  'CUÍCA',
  'CUÍRA',
  'CVIII',
  'CXCIV',
  'CXIII',
  'CXLII',
  'CXLIV',
  'CXLIX',
  'CXLVI',
  'CXVII',
  'CXXII',
  'CXXIV',
  'CXXIX',
  'CXXVI',
  'CXXXI',
  'CXXXV',
  'CÁDIS',
  'CÁLIX',
  'CÁPEA',
  'CÁPUA',
  'CÁRIE',
  'CÁRUS',
  'CÁVEA',
  'CÁVIA',
  'CÂNDI',
  'CÂNON',
  'CÉBUS',
  'CÉCUM',
  'CÉLIO',
  'CÉREO',
  'CÉRIO',
  'CÉSAR',
  'CÉSIO',
  'CÊNIO',
  'CÍLIO',
  'CÍRIO',
  'CÍVEL',
  'CÓBIO',
  'CÓBUS',
  'CÓDEX',
  'CÓDIO',
  'CÓDON',
  'CÓDÃO',
  'CÓFIA',
  'CÓGIA',
  'CÓLEO',
  'CÓLON',
  'CÓPIA',
  'CÓRIO',
  'CÓRIS',
  'CÔDEA',
  'CÚLEX',
  'CÚMIS',
  'CÚNEO',
  'CÚNIA',
  'CÚRIA',
  'CÚTER',
  'CÚTIS',
  'DACAR',
  'DADAS',
  'DADOR',
  'DADOS',
  'DAFNE',
  'DALAI',
  'DALGO',
  'DALÉM',
  'DAMAS',
  'DAMBA',
  'DAMOS',
  'DANAM',
  'DANAR',
  'DANAS',
  'DANCE',
  'DANDO',
  'DANEI',
  'DANEM',
  'DANES',
  'DANOS',
  'DANOU',
  'DANTE',
  'DANÇA',
  'DANÇO',
  'DAQUI',
  'DARDO',
  'DAREI',
  'DAREM',
  'DARES',
  'DARIA',
  'DARMA',
  'DARÁS',
  'DARÃO',
  'DASSA',
  'DATAM',
  'DATAR',
  'DATAS',
  'DATEI',
  'DATEM',
  'DATES',
  'DATIL',
  'DATOU',
  'DAVAM',
  'DAVAS',
  'DAÇÃO',
  'DEADO',
  'DEBAR',
  'DECAI',
  'DECIL',
  'DEDAL',
  'DEDAR',
  'DEDOS',
  'DEDUZ',
  'DEDÃO',
  'DEITA',
  'DEITE',
  'DEITO',
  'DEIXA',
  'DEIXE',
  'DEIXO',
  'DELAS',
  'DELES',
  'DELIR',
  'DELTA',
  'DEMBO',
  'DEMOS',
  'DEMÃO',
  'DENDO',
  'DENDÊ',
  'DENGO',
  'DENSA',
  'DENSO',
  'DENTE',
  'DEPOR',
  'DEPUS',
  'DEPÓS',
  'DEPÕE',
  'DEQUE',
  'DERAM',
  'DERAS',
  'DEREM',
  'DERES',
  'DERMA',
  'DERME',
  'DERMO',
  'DERRE',
  'DESAR',
  'DESCE',
  'DESCI',
  'DESDE',
  'DESMA',
  'DESMO',
  'DESPE',
  'DESPI',
  'DESSA',
  'DESSE',
  'DESTA',
  'DESTE',
  'DESÇA',
  'DESÇO',
  'DETER',
  'DETEU',
  'DETRE',
  'DETÉM',
  'DEUSA',
  'DEVAM',
  'DEVAS',
  'DEVEI',
  'DEVEM',
  'DEVER',
  'DEVES',
  'DEVEU',
  'DEVIA',
  'DEVIR',
  'DIABA',
  'DIABO',
  'DIACO',
  'DIALE',
  'DIANA',
  'DIATE',
  'DIAZO',
  'DICAR',
  'DICAS',
  'DICHA',
  'DIENO',
  'DIESE',
  'DIETA',
  'DIGAM',
  'DIGAR',
  'DIGAS',
  'DIGNA',
  'DIGNE',
  'DIGNO',
  'DILUA',
  'DILUI',
  'DILUO',
  'DIMBA',
  'DINAR',
  'DINCA',
  'DINDA',
  'DINDO',
  'DINGA',
  'DINGO',
  'DIODO',
  'DIOGO',
  'DIOMA',
  'DIONA',
  'DIOSO',
  'DIPLE',
  'DIPLO',
  'DIQUE',
  'DIRCA',
  'DIREI',
  'DIRIA',
  'DIRRÃ',
  'DIRÁS',
  'DIRÃO',
  'DISCA',
  'DISCO',
  'DISPO',
  'DISSE',
  'DISSO',
  'DISTA',
  'DISTE',
  'DISTO',
  'DITAM',
  'DITAR',
  'DITAS',
  'DITEI',
  'DITEM',
  'DITES',
  'DITOS',
  'DITOU',
  'DIVAS',
  'DIVÃO',
  'DIZEI',
  'DIZEM',
  'DIZER',
  'DIZES',
  'DIZIA',
  'DIÇÃO',
  'DOADA',
  'DOADO',
  'DOARA',
  'DOAVA',
  'DOBAR',
  'DOBLA',
  'DOBLE',
  'DOBRA',
  'DOBRE',
  'DOBRO',
  'DOCAS',
  'DOCES',
  'DOCTO',
  'DODÓI',
  'DOERA',
  'DOGMA',
  'DOGON',
  'DOGUE',
  'DOIDA',
  'DOIDO',
  'DOIRA',
  'DOIRO',
  'DOLCE',
  'DOLOR',
  'DOMAM',
  'DOMAR',
  'DOMAS',
  'DOMEI',
  'DOMEM',
  'DOMES',
  'DOMOS',
  'DOMOU',
  'DONAS',
  'DONDE',
  'DONDO',
  'DONGO',
  'DONOS',
  'DONTE',
  'DOPAI',
  'DOPAM',
  'DOPAR',
  'DOPEI',
  'DOPOU',
  'DORES',
  'DORIR',
  'DORME',
  'DORMI',
  'DORMO',
  'DORNA',
  'DORSO',
  'DOSAM',
  'DOSAR',
  'DOSAS',
  'DOSEI',
  'DOSEM',
  'DOSES',
  'DOSOU',
  'DOTAL',
  'DOTAM',
  'DOTAR',
  'DOTAS',
  'DOTEI',
  'DOTEM',
  'DOTES',
  'DOTOU',
  'DOUDA',
  'DOUDO',
  'DOULA',
  'DOURA',
  'DOURE',
  'DOURO',
  'DOUTA',
  'DOUTO',
  'DOÇAR',
  'DOÍAM',
  'DRAGA',
  'DRAGO',
  'DRAMA',
  'DRENA',
  'DRENE',
  'DRENO',
  'DRIVE',
  'DROGA',
  'DROGO',
  'DROMO',
  'DROPE',
  'DRUPA',
  'DRUSA',
  'DRUSO',
  'DUAIS',
  'DUANA',
  'DUBLA',
  'DUBLO',
  'DUBLÊ',
  'DUCAL',
  'DUCHA',
  'DUCHE',
  'DUCTO',
  'DUELA',
  'DUELE',
  'DUELO',
  'DUETO',
  'DUEÇA',
  'DUINA',
  'DULIA',
  'DUMAS',
  'DUMBA',
  'DUMBO',
  'DUNAR',
  'DUNAS',
  'DUNGA',
  'DUNHA',
  'DUPLA',
  'DUPLO',
  'DUQUE',
  'DURAL',
  'DURAM',
  'DURAR',
  'DURAS',
  'DUREI',
  'DUREM',
  'DURES',
  'DUREX',
  'DUREZ',
  'DURGÁ',
  'DURMA',
  'DURMO',
  'DUROS',
  'DUROU',
  'DURRA',
  'DURÃO',
  'DUTOS',
  'DUZIR',
  'DÁCIO',
  'DÁLIA',
  'DÂMAR',
  'DÂNDI',
  'DÉBIL',
  'DÉCOR',
  'DÉLIA',
  'DÉLIO',
  'DÉRBI',
  'DÉVIO',
  'DÍADA',
  'DÍADE',
  'DÍOPE',
  'DÍSEL',
  'DÓCIL',
  'DÓLAR',
  'DÓLIO',
  'DÓLMÃ',
  'DÓRIA',
  'DÓRIO',
  'DÓRIS',
  'DÚBIA',
  'DÚBIO',
  'DÚZIA',
  'EBOLA',
  'EBOMI',
  'ECLER',
  'ECOAM',
  'ECOAR',
  'ECOAS',
  'ECOEI',
  'ECOEM',
  'ECOOU',
  'EDEMA',
  'EDITA',
  'EDITE',
  'EDITO',
  'EDUCA',
  'EDUCO',
  'EDULE',
  'EFEBO',
  'EGESA',
  'EIDOS',
  'EIMAR',
  'EIRAS',
  'EIRÓS',
  'EIVAR',
  'EIXAR',
  'EIXOS',
  'EJETA',
  'EJETE',
  'EJETO',
  'ELANO',
  'ELCHE',
  'ELEDÁ',
  'ELEGE',
  'ELEGI',
  'ELEJA',
  'ELEJO',
  'ELEMI',
  'ELENA',
  'ELEPÊ',
  'ELETO',
  'ELEVA',
  'ELEVE',
  'ELEVO',
  'ELINA',
  'ELITE',
  'ELMOS',
  'ELONA',
  'ELUIR',
  'ELÉIS',
  'EMANA',
  'EMANE',
  'EMANO',
  'EMBOÁ',
  'EMBUÁ',
  'EMEIO',
  'EMFIM',
  'EMINS',
  'EMITA',
  'EMITE',
  'EMITI',
  'EMITO',
  'EMOTO',
  'EMPAR',
  'EMPÓS',
  'EMULA',
  'EMULE',
  'ENANO',
  'ENASE',
  'ENCHA',
  'ENCHE',
  'ENCHI',
  'ENCHÓ',
  'ENDES',
  'ENDRO',
  'ENEMA',
  'ENFIA',
  'ENFIE',
  'ENFIM',
  'ENFIO',
  'ENGAR',
  'ENGOS',
  'ENGRA',
  'ENINO',
  'ENJOA',
  'ENJOE',
  'ENJOO',
  'ENOJA',
  'ENOJE',
  'ENOJO',
  'ENORA',
  'ENQUE',
  'ENTER',
  'ENTES',
  'ENTEU',
  'ENTOA',
  'ENTOE',
  'ENTRA',
  'ENTRE',
  'ENTRO',
  'ENTÃO',
  'ENVIA',
  'ENVIE',
  'ENVIO',
  'ENVÉS',
  'ENXÓS',
  'EPATA',
  'EPODO',
  'EPÓXI',
  'ERADO',
  'ERAMÁ',
  'ERATO',
  'ERETA',
  'ERETO',
  'ERGAM',
  'ERGAS',
  'ERGIA',
  'ERGUE',
  'ERGUI',
  'ERICE',
  'ERIGE',
  'ERIGI',
  'ERIJA',
  'ERIJO',
  'ERMAL',
  'ERMOS',
  'ERODE',
  'ERRAM',
  'ERRAR',
  'ERRAS',
  'ERREI',
  'ERREM',
  'ERRES',
  'ERROR',
  'ERROS',
  'ERROU',
  'ERUCA',
  'ERVAL',
  'ERVAR',
  'ERVAS',
  'ESCOA',
  'ESCOE',
  'ESCOL',
  'ESGAR',
  'ESMAR',
  'ESPIA',
  'ESPIE',
  'ESPIM',
  'ESPIO',
  'ESPRU',
  'ESQUI',
  'ESSAS',
  'ESSES',
  'ESTAI',
  'ESTAR',
  'ESTAS',
  'ESTAU',
  'ESTER',
  'ESTES',
  'ESTIA',
  'ESTIO',
  'ESTOL',
  'ESTOU',
  'ESTRO',
  'ESTUO',
  'ESTÃO',
  'ESVAI',
  'ETANO',
  'ETAPA',
  'ETEMO',
  'ETENO',
  'ETERA',
  'ETHOS',
  'ETILA',
  'ETILO',
  'ETINO',
  'ETNIA',
  'EVADA',
  'EVADE',
  'EVADI',
  'EVADO',
  'EVALE',
  'EVASÊ',
  'EVITA',
  'EVITE',
  'EVITO',
  'EVOCA',
  'EVOCO',
  'EXALA',
  'EXALE',
  'EXALO',
  'EXAME',
  'EXARA',
  'EXARE',
  'EXARO',
  'EXATA',
  'EXATO',
  'EXIBA',
  'EXIBE',
  'EXIBI',
  'EXIBO',
  'EXIDO',
  'EXIGE',
  'EXIGI',
  'EXIJA',
  'EXIJO',
  'EXILA',
  'EXILE',
  'EXILO',
  'EXIMA',
  'EXIME',
  'EXIMI',
  'EXIMO',
  'EXINA',
  'EXPIA',
  'EXPIE',
  'EXPIO',
  'EXPOR',
  'EXPUS',
  'EXPÔS',
  'EXPÕE',
  'EXTRA',
  'EXUMA',
  'EXUME',
  'EÓLIA',
  'EÓLIO',
  'FABRO',
  'FACAS',
  'FACES',
  'FACHA',
  'FACHI',
  'FACHO',
  'FACIE',
  'FACÃO',
  'FADAR',
  'FADAS',
  'FADIM',
  'FADIÁ',
  'FADOS',
  'FAECE',
  'FAGAR',
  'FAGIA',
  'FAIAL',
  'FAIAR',
  'FAIAS',
  'FAINA',
  'FAIRE',
  'FAITE',
  'FAIXA',
  'FAJAU',
  'FALAI',
  'FALAM',
  'FALAR',
  'FALAS',
  'FALAZ',
  'FALCA',
  'FALCI',
  'FALCO',
  'FALDA',
  'FALEI',
  'FALEM',
  'FALES',
  'FALHA',
  'FALHE',
  'FALHO',
  'FALIA',
  'FALIR',
  'FALIS',
  'FALIU',
  'FALOU',
  'FALSA',
  'FALSO',
  'FALTA',
  'FALTE',
  'FALTO',
  'FALUA',
  'FAMAS',
  'FANAL',
  'FANAR',
  'FANCA',
  'FANDO',
  'FANFA',
  'FANGA',
  'FANHA',
  'FANHO',
  'FANTE',
  'FANTÃ',
  'FAQUI',
  'FARAD',
  'FARAR',
  'FARDA',
  'FARDO',
  'FAREI',
  'FAREL',
  'FARIA',
  'FARME',
  'FAROL',
  'FAROS',
  'FARPA',
  'FARRA',
  'FARRO',
  'FARSA',
  'FARTA',
  'FARTE',
  'FARTO',
  'FARÁS',
  'FARÃO',
  'FASCO',
  'FASES',
  'FASOR',
  'FASTA',
  'FASTO',
  'FATAL',
  'FATIA',
  'FATIE',
  'FATIO',
  'FATOR',
  'FATOS',
  'FATÃO',
  'FAUCE',
  'FAUNA',
  'FAUNO',
  'FAVAL',
  'FAVAR',
  'FAVAS',
  'FAVOR',
  'FAVOS',
  'FAXES',
  'FAZEI',
  'FAZEM',
  'FAZER',
  'FAZES',
  'FAZIA',
  'FAÇAM',
  'FAÚLA',
  'FEBRA',
  'FEBRE',
  'FECAL',
  'FECHA',
  'FECHE',
  'FECHO',
  'FEDAS',
  'FEDEM',
  'FEDER',
  'FEDES',
  'FEDEU',
  'FEDIA',
  'FEDOR',
  'FEDRA',
  'FEIAS',
  'FEILA',
  'FEIOS',
  'FEIRA',
  'FEITA',
  'FEITO',
  'FEIXE',
  'FEIÃO',
  'FELAR',
  'FELGA',
  'FELIZ',
  'FELPA',
  'FELPO',
  'FENAL',
  'FENDA',
  'FENDE',
  'FENDI',
  'FENDO',
  'FENIM',
  'FENOL',
  'FENTO',
  'FERAL',
  'FERAS',
  'FERAZ',
  'FEREM',
  'FERES',
  'FERIA',
  'FERIR',
  'FERIS',
  'FERIU',
  'FERMI',
  'FEROS',
  'FEROZ',
  'FERPA',
  'FERRA',
  'FERRE',
  'FERRO',
  'FERVA',
  'FERVE',
  'FERVI',
  'FERVO',
  'FESTA',
  'FESTO',
  'FETAL',
  'FETOS',
  'FETUS',
  'FEUDO',
  'FEZES',
  'FIADA',
  'FIADO',
  'FIAIS',
  'FIAPO',
  'FIARA',
  'FIAVA',
  'FIBRA',
  'FIBRO',
  'FICAI',
  'FICAM',
  'FICAR',
  'FICAS',
  'FICHA',
  'FICHE',
  'FICHO',
  'FICHU',
  'FICOU',
  'FICTO',
  'FICÃO',
  'FIGAR',
  'FIGAS',
  'FIGOS',
  'FILAM',
  'FILAR',
  'FILAS',
  'FILEI',
  'FILEM',
  'FILES',
  'FILHA',
  'FILHO',
  'FILIA',
  'FILIE',
  'FILIO',
  'FILMA',
  'FILME',
  'FILMO',
  'FILOS',
  'FILOU',
  'FILÃO',
  'FINAL',
  'FINAR',
  'FINAS',
  'FINCA',
  'FINCO',
  'FINDA',
  'FINDE',
  'FINDO',
  'FINFA',
  'FINGE',
  'FINGI',
  'FINGO',
  'FINJA',
  'FINJO',
  'FINOS',
  'FINTA',
  'FINTE',
  'FINTO',
  'FINÊS',
  'FIOFÓ',
  'FIOTA',
  'FIOTE',
  'FIQUE',
  'FIRAM',
  'FIRAS',
  'FIRMA',
  'FIRME',
  'FIRMO',
  'FISCO',
  'FISGA',
  'FISGO',
  'FISIO',
  'FISMA',
  'FITAM',
  'FITAR',
  'FITAS',
  'FITEI',
  'FITEM',
  'FITES',
  'FITOL',
  'FITOU',
  'FITÃO',
  'FIXAI',
  'FIXAM',
  'FIXAR',
  'FIXAS',
  'FIXEI',
  'FIXEM',
  'FIXES',
  'FIXOS',
  'FIXOU',
  'FIZER',
  'FIÉIS',
  'FIÚSA',
  'FIÚZA',
  'FLACO',
  'FLAMA',
  'FLAME',
  'FLAPE',
  'FLARE',
  'FLASH',
  'FLATO',
  'FLAVA',
  'FLAVO',
  'FLETE',
  'FLEXO',
  'FLOCO',
  'FLOGO',
  'FLORA',
  'FLORI',
  'FLOXO',
  'FLOZÔ',
  'FLUAM',
  'FLUEM',
  'FLUIR',
  'FLUIS',
  'FLUIU',
  'FLUME',
  'FLUSH',
  'FLUTA',
  'FLUXO',
  'FLUÍA',
  'FLÚOR',
  'FOBIA',
  'FOBOS',
  'FOCAI',
  'FOCAL',
  'FOCAM',
  'FOCAR',
  'FOCAS',
  'FOCOS',
  'FOCOU',
  'FOCUS',
  'FODER',
  'FODEU',
  'FOFAR',
  'FOFAS',
  'FOFOS',
  'FOFÃO',
  'FOGAR',
  'FOGEM',
  'FOGES',
  'FOGOS',
  'FOGÃO',
  'FOICE',
  'FOIDE',
  'FOINA',
  'FOITO',
  'FOLAR',
  'FOLES',
  'FOLGA',
  'FOLGO',
  'FOLHA',
  'FOLHO',
  'FOLIA',
  'FOMES',
  'FOMOS',
  'FONES',
  'FONIA',
  'FONTE',
  'FONÃO',
  'FOQUE',
  'FORAL',
  'FORAM',
  'FORAS',
  'FORCE',
  'FORDE',
  'FOREM',
  'FORES',
  'FORIA',
  'FORJA',
  'FORJE',
  'FORJO',
  'FORMA',
  'FORME',
  'FORMI',
  'FORMO',
  'FORNO',
  'FOROS',
  'FORRA',
  'FORRE',
  'FORRÓ',
  'FORTE',
  'FORÇA',
  'FORÇO',
  'FOSCA',
  'FOSCO',
  'FOSGA',
  'FOSSA',
  'FOSSE',
  'FOSSO',
  'FOSTE',
  'FOTOS',
  'FOTÃO',
  'FOUCE',
  'FOYER',
  'FRACA',
  'FRACO',
  'FRADE',
  'FRAGA',
  'FRAGO',
  'FRAMA',
  'FRAPÊ',
  'FRASE',
  'FREAR',
  'FREEI',
  'FREGA',
  'FREGE',
  'FREIA',
  'FREIE',
  'FREIO',
  'FREME',
  'FREON',
  'FREOU',
  'FRESA',
  'FRESE',
  'FRESO',
  'FRETA',
  'FRETE',
  'FRETO',
  'FREVO',
  'FRIAS',
  'FRIEZ',
  'FRIGE',
  'FRIGI',
  'FRIGO',
  'FRILA',
  'FRINE',
  'FRIOS',
  'FRISA',
  'FRISE',
  'FRISO',
  'FRITA',
  'FRITE',
  'FRITO',
  'FROCO',
  'FROTA',
  'FROZÔ',
  'FRUAM',
  'FRUAS',
  'FRUEM',
  'FRUIR',
  'FRUIU',
  'FRUTA',
  'FRUTO',
  'FRUÍA',
  'FUCEI',
  'FUCEM',
  'FUCIM',
  'FUGAR',
  'FUGAS',
  'FUGAZ',
  'FUGIA',
  'FUGIR',
  'FUGIS',
  'FUGIU',
  'FUGÃO',
  'FUJAM',
  'FUJAS',
  'FUJIR',
  'FUJÃO',
  'FULAR',
  'FULAS',
  'FULDA',
  'FULGE',
  'FULHA',
  'FULOS',
  'FULVO',
  'FULÃO',
  'FUMAM',
  'FUMAR',
  'FUMAS',
  'FUMEI',
  'FUMEM',
  'FUMES',
  'FUMOS',
  'FUMOU',
  'FUMÃO',
  'FUNCA',
  'FUNCO',
  'FUNDA',
  'FUNDE',
  'FUNDI',
  'FUNDO',
  'FUNGA',
  'FUNGE',
  'FUNGO',
  'FUNIL',
  'FUNIS',
  'FUNJE',
  'FUQUE',
  'FURAI',
  'FURAM',
  'FURAR',
  'FURAS',
  'FUREI',
  'FUREM',
  'FURES',
  'FURNA',
  'FUROR',
  'FUROS',
  'FUROU',
  'FURTA',
  'FURTE',
  'FURTO',
  'FURÃO',
  'FUSAR',
  'FUSCA',
  'FUSCO',
  'FUSOR',
  'FUSOS',
  'FUSTA',
  'FUSTE',
  'FUSÃO',
  'FUTRE',
  'FUTUM',
  'FUZIL',
  'FUZIS',
  'FUZUÊ',
  'FUÇAM',
  'FUÇAR',
  'FUÇAS',
  'FUÇOU',
  'FÁCIL',
  'FÁLUS',
  'FÁRIO',
  'FÁSIA',
  'FÁTUO',
  'FÁVIO',
  'FÂNTI',
  'FÊMEA',
  'FÊMEO',
  'FÊMUR',
  'FÊNIX',
  'FÍALA',
  'FÍCIS',
  'FÍCUS',
  'FÍFIA',
  'FÍLEO',
  'FÍLER',
  'FÓCIO',
  'FÓDIA',
  'FÓLIO',
  'FÓLIS',
  'FÓRUM',
  'FÓTON',
  'FÓVEA',
  'FÔNON',
  'FÚRIA',
  'FÚSEL',
  'FÚSIL',
  'FÚTIL',
  'GABAM',
  'GABAR',
  'GABAS',
  'GABEI',
  'GABEM',
  'GABES',
  'GABOU',
  'GABRO',
  'GABÃO',
  'GACHA',
  'GACHO',
  'GADOS',
  'GAETA',
  'GAGAS',
  'GAGAU',
  'GAGOS',
  'GAGUE',
  'GAIAS',
  'GAIOS',
  'GAITA',
  'GAIVA',
  'GAJAS',
  'GAJOS',
  'GALAR',
  'GALAS',
  'GALES',
  'GALGA',
  'GALGO',
  'GALHA',
  'GALHO',
  'GALOS',
  'GALRA',
  'GALÃO',
  'GAMAR',
  'GAMBA',
  'GAMBO',
  'GAMÃO',
  'GANDA',
  'GANDO',
  'GANEM',
  'GANGA',
  'GANGO',
  'GANHA',
  'GANHE',
  'GANHO',
  'GANIA',
  'GANIR',
  'GANIU',
  'GANJA',
  'GANSA',
  'GANSO',
  'GANTA',
  'GANZA',
  'GANZÉ',
  'GANÇA',
  'GANÇO',
  'GANÊS',
  'GARBO',
  'GARFA',
  'GARFE',
  'GARFO',
  'GARGÓ',
  'GARIS',
  'GARNA',
  'GAROA',
  'GARRA',
  'GARRO',
  'GARUA',
  'GARÃO',
  'GARÇA',
  'GARÇO',
  'GASES',
  'GASPA',
  'GASTA',
  'GASTE',
  'GASTO',
  'GATAL',
  'GATAR',
  'GATAS',
  'GATEU',
  'GATIL',
  'GATOS',
  'GATÃO',
  'GAUDA',
  'GAURA',
  'GAURO',
  'GAUSS',
  'GAVAR',
  'GAZAL',
  'GAZAR',
  'GAZEL',
  'GAZUA',
  'GEADA',
  'GEADO',
  'GEAIS',
  'GEARA',
  'GEASE',
  'GEENA',
  'GELAM',
  'GELAR',
  'GELAS',
  'GELEI',
  'GELEM',
  'GELES',
  'GELFA',
  'GELHA',
  'GELOS',
  'GELOU',
  'GEMAM',
  'GEMAR',
  'GEMAS',
  'GEMEI',
  'GEMEM',
  'GEMER',
  'GEMES',
  'GEMEU',
  'GEMIA',
  'GENAL',
  'GENES',
  'GENIA',
  'GENOA',
  'GENRO',
  'GENTE',
  'GEODE',
  'GEODO',
  'GEOSO',
  'GERAI',
  'GERAL',
  'GERAM',
  'GERAR',
  'GERAS',
  'GERBO',
  'GEREI',
  'GERES',
  'GERIA',
  'GERIR',
  'GERIS',
  'GERIU',
  'GERME',
  'GEROU',
  'GERRE',
  'GERÉM',
  'GESSO',
  'GESTA',
  'GESTO',
  'GETAS',
  'GETEU',
  'GIBÃO',
  'GICLÊ',
  'GIGLÊ',
  'GIMEL',
  'GINCO',
  'GINDO',
  'GINGA',
  'GINGE',
  'GINGO',
  'GINJA',
  'GIPSO',
  'GIRAM',
  'GIRAR',
  'GIRAS',
  'GIREI',
  'GIREM',
  'GIROS',
  'GIROU',
  'GIRÃO',
  'GITEU',
  'GIZAR',
  'GLACÊ',
  'GLEBA',
  'GLETE',
  'GLIAL',
  'GLIDE',
  'GLIFO',
  'GLOBA',
  'GLOBO',
  'GLOSA',
  'GLOSO',
  'GLOTE',
  'GLUMA',
  'GLUTE',
  'GLUÃO',
  'GLÚON',
  'GNOMA',
  'GNOMO',
  'GNOSE',
  'GODOS',
  'GODÃO',
  'GOELA',
  'GOFER',
  'GOITA',
  'GOIVA',
  'GOIVO',
  'GOIÁS',
  'GOLAS',
  'GOLES',
  'GOLEÁ',
  'GOLFE',
  'GOLFO',
  'GOLIM',
  'GOLPE',
  'GOMAR',
  'GOMAS',
  'GOMBA',
  'GOMBE',
  'GOMBÔ',
  'GOMES',
  'GOMIL',
  'GOMOS',
  'GONDA',
  'GONDI',
  'GONDO',
  'GONEL',
  'GONGA',
  'GONGO',
  'GONZO',
  'GORAL',
  'GORAM',
  'GORAR',
  'GORAS',
  'GORAZ',
  'GORDA',
  'GORDO',
  'GORES',
  'GORGA',
  'GORJA',
  'GORNE',
  'GOROU',
  'GORRA',
  'GORRO',
  'GOSMA',
  'GOSTA',
  'GOSTE',
  'GOSTO',
  'GOTAS',
  'GOTÃO',
  'GOUDA',
  'GOZAI',
  'GOZAM',
  'GOZAR',
  'GOZAS',
  'GOZEI',
  'GOZEM',
  'GOZES',
  'GOZOS',
  'GOZOU',
  'GOZÃO',
  'GRAAL',
  'GRABE',
  'GRADA',
  'GRADE',
  'GRADO',
  'GRAFA',
  'GRAFE',
  'GRAFO',
  'GRAMA',
  'GRANA',
  'GRANE',
  'GRANI',
  'GRAPA',
  'GRATA',
  'GRATO',
  'GRAUS',
  'GRAVA',
  'GRAVE',
  'GRAVO',
  'GRAXA',
  'GRAXO',
  'GRAÇA',
  'GREBE',
  'GRECO',
  'GREDA',
  'GREDE',
  'GREGA',
  'GREGO',
  'GREIA',
  'GRELA',
  'GRELO',
  'GRENÁ',
  'GRETA',
  'GREVA',
  'GREVE',
  'GRIFA',
  'GRIFE',
  'GRIFO',
  'GRILA',
  'GRILE',
  'GRILO',
  'GRIMA',
  'GRIPA',
  'GRIPE',
  'GRISE',
  'GRISO',
  'GRISU',
  'GRITA',
  'GRITE',
  'GRITO',
  'GROMA',
  'GROOM',
  'GROSA',
  'GROTA',
  'GROUS',
  'GRUDA',
  'GRUDE',
  'GRUDO',
  'GRUMO',
  'GRUNA',
  'GRUPA',
  'GRUPO',
  'GRUTA',
  'GRÃOS',
  'GUACO',
  'GUACÁ',
  'GUADO',
  'GUAIA',
  'GUAIÓ',
  'GUAIÚ',
  'GUAJÁ',
  'GUANO',
  'GUANÁ',
  'GUAPO',
  'GUARE',
  'GUARI',
  'GUARU',
  'GUARÁ',
  'GUATÓ',
  'GUAXE',
  'GUAXO',
  'GUAÇU',
  'GUEBA',
  'GUEBO',
  'GUEDÉ',
  'GUERE',
  'GUERI',
  'GUETA',
  'GUETE',
  'GUETO',
  'GUIAI',
  'GUIAM',
  'GUIAR',
  'GUIAS',
  'GUIBÁ',
  'GUIEI',
  'GUIEM',
  'GUIES',
  'GUIGA',
  'GUIGÓ',
  'GUINA',
  'GUINO',
  'GUINÉ',
  'GUIOU',
  'GUIRA',
  'GUIRI',
  'GUISA',
  'GUITA',
  'GUITO',
  'GUIZO',
  'GUIÃO',
  'GULAR',
  'GUMBO',
  'GUMBÉ',
  'GUMES',
  'GUNDA',
  'GUNGA',
  'GUNJI',
  'GURAL',
  'GURDE',
  'GURIA',
  'GURIS',
  'GURRA',
  'GUTAR',
  'GÁBIA',
  'GÁLAX',
  'GÁLEA',
  'GÁLEO',
  'GÁLIA',
  'GÁLIO',
  'GÁVEA',
  'GÁZIO',
  'GÂMIA',
  'GÉRON',
  'GÊMEA',
  'GÊMEO',
  'GÊNIO',
  'GÍRIA',
  'GÍRIO',
  'GÓBIO',
  'GÓDIA',
  'GÔNIO',
  'HACER',
  'HADJI',
  'HAJAM',
  'HAJAS',
  'HALMA',
  'HALOS',
  'HALVÁ',
  'HAMSA',
  'HANDA',
  'HANHA',
  'HANSA',
  'HAOMA',
  'HAPLO',
  'HAPTO',
  'HARAS',
  'HARLO',
  'HARPA',
  'HARPE',
  'HARTO',
  'HARÉM',
  'HASTA',
  'HASTE',
  'HAURA',
  'HAURE',
  'HAURI',
  'HAUÇÁ',
  'HAVEI',
  'HAVER',
  'HAVIA',
  'HECTO',
  'HEDRA',
  'HEMAL',
  'HENRY',
  'HEPTA',
  'HERAS',
  'HERDA',
  'HERDE',
  'HERDO',
  'HERMA',
  'HERSE',
  'HERTZ',
  'HERÓI',
  'HETEU',
  'HEVEU',
  'HEXAL',
  'HEXIL',
  'HIATO',
  'HICSO',
  'HIDRA',
  'HIDRO',
  'HIENA',
  'HIFAL',
  'HIGGS',
  'HIGRA',
  'HIGRO',
  'HILAR',
  'HIMBA',
  'HINDU',
  'HINOS',
  'HIPER',
  'HIPNO',
  'HIRTO',
  'HISTO',
  'HOBBY',
  'HOMEM',
  'HOMEO',
  'HOMOS',
  'HOMÃO',
  'HONGO',
  'HONOR',
  'HONRA',
  'HONRE',
  'HONRO',
  'HORAL',
  'HORAR',
  'HORAS',
  'HORDA',
  'HOREU',
  'HORRÁ',
  'HORSA',
  'HORTA',
  'HORTO',
  'HORÃO',
  'HOSTE',
  'HOTEL',
  'HOUVE',
  'HUARI',
  'HUIDO',
  'HULHA',
  'HUMBE',
  'HUMBI',
  'HUMBO',
  'HUMOR',
  'HUNOS',
  'HURRA',
  'HUÍLA',
  'HÁBIA',
  'HÁBIL',
  'HÁDEN',
  'HÁLEX',
  'HÁLIS',
  'HÁLUX',
  'HÁPAX',
  'HÉLAS',
  'HÉLIO',
  'HÉLIX',
  'HÉVEA',
  'HÍFEN',
  'HÍMEN',
  'HÍNDI',
  'HÍRAX',
  'HÚMUS',
  'IAGUÁ',
  'IAMBO',
  'IANDE',
  'IANSÃ',
  'IAQUE',
  'IATAÍ',
  'IATES',
  'IBEJI',
  'IBERE',
  'IBERO',
  'IBIRA',
  'IBIRI',
  'IBOGA',
  'IBOPE',
  'ICACO',
  'ICEIS',
  'ICTIO',
  'IDADE',
  'IDATE',
  'IDEAL',
  'IDEAR',
  'IDOSA',
  'IDOSO',
  'IDEIA',
  'IENES',
  'IGACI',
  'IGAPÓ',
  'IGARA',
  'IGUAL',
  'IGUAR',
  'IJEXÁ',
  'ILEAL',
  'ILESA',
  'ILESO',
  'ILHAM',
  'ILHAR',
  'ILHAS',
  'ILHOA',
  'ILHOU',
  'ILHÉU',
  'ILHÓS',
  'ILITA',
  'ILITE',
  'ILUDA',
  'ILUDE',
  'ILUDI',
  'ILUDO',
  'ILUSO',
  'IMAGO',
  'IMAME',
  'IMANE',
  'IMANO',
  'IMBUA',
  'IMIDA',
  'IMIGO',
  'IMINA',
  'IMITA',
  'IMITE',
  'IMITO',
  'IMOLA',
  'IMOLE',
  'IMOLO',
  'IMOTO',
  'IMPOL',
  'IMPOR',
  'IMPUS',
  'IMPÔS',
  'IMPÕE',
  'IMUNE',
  'INAIÁ',
  'INAJÁ',
  'INALA',
  'INALE',
  'INALO',
  'INAMA',
  'INAME',
  'INANA',
  'INANE',
  'INATA',
  'INATO',
  'INCAS',
  'INCHA',
  'INCHE',
  'INCHO',
  'INDAS',
  'INDEX',
  'INDEZ',
  'INDOL',
  'INDUZ',
  'INEXO',
  'INFLA',
  'INFLE',
  'INFLO',
  'INFRA',
  'INGAÍ',
  'INGRE',
  'INIBA',
  'INIBE',
  'INIBI',
  'INIBO',
  'INITE',
  'INJOU',
  'INOVA',
  'INOVE',
  'INOVO',
  'INPUT',
  'INSTA',
  'INSTE',
  'INSTO',
  'INTER',
  'INTRA',
  'INTUA',
  'INTUI',
  'INTUO',
  'INVAR',
  'INVÉS',
  'IODOS',
  'IOGAS',
  'IOGUE',
  'IPACA',
  'IPADU',
  'IPECA',
  'IPETÊ',
  'IPPAR',
  'IRADA',
  'IRADE',
  'IRADO',
  'IRANI',
  'IRARA',
  'IRDES',
  'IREIS',
  'IREMO',
  'IRENE',
  'IRENO',
  'IRERÊ',
  'IRIAL',
  'IRIAM',
  'IRIAR',
  'IRIAS',
  'IRINO',
  'IRIRÁ',
  'IRITE',
  'IRMOS',
  'IRMÃO',
  'IRMÃS',
  'IROCO',
  'IROSO',
  'ISALA',
  'ISCAR',
  'ISCAS',
  'ISLÃO',
  'ISOCA',
  'ISOLA',
  'ISOLE',
  'ISOLO',
  'ISSEI',
  'ISTMO',
  'ISTRO',
  'ITANO',
  'ITAPU',
  'ITATI',
  'ITENS',
  'ITERA',
  'ITERE',
  'ITERO',
  'ITOBI',
  'IUANE',
  'IXORA',
  'IZUZO',
  'IÁSIS',
  'IÇADA',
  'IÇADO',
  'IÇARA',
  'IÇAVA',
  'IÔNIO',
  'JABRE',
  'JACAS',
  'JACUÍ',
  'JADES',
  'JAGAS',
  'JAINA',
  'JALDE',
  'JALES',
  'JALNE',
  'JAMBA',
  'JAMBO',
  'JAMBU',
  'JAMBÉ',
  'JANDA',
  'JANGA',
  'JANGO',
  'JANJA',
  'JANTA',
  'JANTE',
  'JANTO',
  'JAPIM',
  'JAPÃO',
  'JAQUE',
  'JARDA',
  'JARDO',
  'JARRA',
  'JARRO',
  'JASPE',
  'JASSO',
  'JATAR',
  'JATAÍ',
  'JATIS',
  'JATOS',
  'JAULA',
  'JAVAÉ',
  'JAZAM',
  'JAZEM',
  'JAZER',
  'JAZES',
  'JAZEU',
  'JAZIA',
  'JEANS',
  'JECAS',
  'JEGUE',
  'JEIRA',
  'JEITO',
  'JEJUA',
  'JEJUE',
  'JEJUM',
  'JEJUO',
  'JEOVÁ',
  'JEQUE',
  'JEQUI',
  'JESSÉ',
  'JESUS',
  'JETOM',
  'JIHAD',
  'JIMBO',
  'JINGA',
  'JINGO',
  'JIPÃO',
  'JIQUI',
  'JIRAU',
  'JOANE',
  'JOGAI',
  'JOGAM',
  'JOGAR',
  'JOGAS',
  'JOGOS',
  'JOGOU',
  'JOGUE',
  'JOGÃO',
  'JOINA',
  'JOLDA',
  'JONGO',
  'JORGE',
  'JORNA',
  'JORRA',
  'JORRE',
  'JORRO',
  'JOULE',
  'JOVEM',
  'JUANA',
  'JUARI',
  'JUBAS',
  'JUBAÍ',
  'JUDAS',
  'JUDEU',
  'JUDIA',
  'JUDIE',
  'JUDIO',
  'JUGAL',
  'JUGAR',
  'JUGOS',
  'JUINA',
  'JULGA',
  'JULGO',
  'JULHO',
  'JUMAS',
  'JUNCO',
  'JUNDO',
  'JUNDU',
  'JUNGO',
  'JUNHO',
  'JUNTA',
  'JUNTE',
  'JUNTO',
  'JUNÇA',
  'JUPIÁ',
  'JURAI',
  'JURAM',
  'JURAR',
  'JURAS',
  'JUREI',
  'JUREM',
  'JURES',
  'JURIS',
  'JUROS',
  'JUROU',
  'JUSTA',
  'JUSTO',
  'JUTAS',
  'JUTAÍ',
  'JUÍZA',
  'JUÍZO',
  'JÁCIO',
  'JÁLEO',
  'JÓIAS',
  'JÔNIO',
  'JÚVIA',
  'KHMER',
  'KRILL',
  'KYRIE',
  'LABOR',
  'LABRO',
  'LABÃO',
  'LABÉU',
  'LACAS',
  'LACEI',
  'LACEM',
  'LACES',
  'LACHA',
  'LACRA',
  'LACRE',
  'LACRO',
  'LADIM',
  'LADOS',
  'LADRA',
  'LADRE',
  'LADRO',
  'LADÃO',
  'LAGAR',
  'LAGES',
  'LAGOA',
  'LAGOS',
  'LAGÃO',
  'LAICA',
  'LAICO',
  'LAIVO',
  'LAJEM',
  'LAJES',
  'LAJÃO',
  'LALAR',
  'LALAU',
  'LALIA',
  'LAMAS',
  'LAMBA',
  'LAMBE',
  'LAMBI',
  'LAMBO',
  'LAMBU',
  'LAMPA',
  'LAMPO',
  'LANAR',
  'LANCE',
  'LANDA',
  'LANDE',
  'LANDI',
  'LANDU',
  'LANDÓ',
  'LANGI',
  'LANGO',
  'LANHA',
  'LANHO',
  'LANÇA',
  'LANÇO',
  'LAPAS',
  'LAPES',
  'LAPSO',
  'LAPUZ',
  'LAPÃO',
  'LAQUÊ',
  'LARAU',
  'LARDO',
  'LARES',
  'LARGA',
  'LARGO',
  'LARVA',
  'LARÉU',
  'LASCA',
  'LASCO',
  'LASER',
  'LASSA',
  'LASSO',
  'LATAS',
  'LATEM',
  'LATER',
  'LATES',
  'LATIA',
  'LATIM',
  'LATIR',
  'LATIS',
  'LATIU',
  'LATÃO',
  'LAUDA',
  'LAUDE',
  'LAUDO',
  'LAURO',
  'LAUTO',
  'LAVAI',
  'LAVAM',
  'LAVAR',
  'LAVAS',
  'LAVEI',
  'LAVEM',
  'LAVES',
  'LAVOR',
  'LAVOU',
  'LAVRA',
  'LAVRE',
  'LAVRO',
  'LAXAR',
  'LAZER',
  'LAZÃO',
  'LAÇAM',
  'LAÇAR',
  'LAÇOS',
  'LAÇOU',
  'LAÇÃO',
  'LEAIS',
  'LEBRE',
  'LECAL',
  'LEDES',
  'LEDOR',
  'LEDOS',
  'LEDRA',
  'LEGAI',
  'LEGAL',
  'LEGAM',
  'LEGAR',
  'LEGAS',
  'LEGBA',
  'LEGIS',
  'LEGOU',
  'LEGRA',
  'LEGRE',
  'LEGUE',
  'LEGÃO',
  'LEIAM',
  'LEIAS',
  'LEIGA',
  'LEIGO',
  'LEILA',
  'LEIRA',
  'LEITA',
  'LEITE',
  'LEITO',
  'LEIVA',
  'LEIXA',
  'LELÉS',
  'LEMAS',
  'LEMBA',
  'LEMBO',
  'LEMES',
  'LEMOS',
  'LENCA',
  'LENDA',
  'LENDE',
  'LENDO',
  'LENDU',
  'LENGA',
  'LENHA',
  'LENHO',
  'LENIR',
  'LENIS',
  'LENTA',
  'LENTE',
  'LENTO',
  'LENÇO',
  'LEOAS',
  'LEONE',
  'LEPRA',
  'LEPTO',
  'LEQUE',
  'LERAM',
  'LERAS',
  'LERDA',
  'LERDO',
  'LEREI',
  'LEREM',
  'LERES',
  'LERIA',
  'LERNA',
  'LERÃO',
  'LESAM',
  'LESAR',
  'LESAS',
  'LESEI',
  'LESEM',
  'LESES',
  'LESMA',
  'LESOU',
  'LESSE',
  'LESTE',
  'LESTO',
  'LESÃO',
  'LETAL',
  'LETRA',
  'LETRO',
  'LETÃO',
  'LEUCO',
  'LEVAI',
  'LEVAM',
  'LEVAR',
  'LEVAS',
  'LEVEI',
  'LEVEM',
  'LEVES',
  'LEVEZ',
  'LEVOU',
  'LEXIA',
  'LEÕES',
  'LHAMA',
  'LHANO',
  'LIAME',
  'LIANA',
  'LIASE',
  'LIBAR',
  'LIBRA',
  'LIBRO',
  'LIBRÉ',
  'LICEU',
  'LICHI',
  'LICOR',
  'LICRA',
  'LIDAM',
  'LIDAR',
  'LIDAS',
  'LIDEI',
  'LIDEM',
  'LIDES',
  'LIDOS',
  'LIDOU',
  'LIGAI',
  'LIGAL',
  'LIGAM',
  'LIGAR',
  'LIGAS',
  'LIGHT',
  'LIGOU',
  'LIGUE',
  'LILÁS',
  'LIMAI',
  'LIMAM',
  'LIMAR',
  'LIMAS',
  'LIMBO',
  'LIMEI',
  'LIMEM',
  'LIMES',
  'LIMOS',
  'LIMOU',
  'LIMPA',
  'LIMPE',
  'LIMPO',
  'LIMÃO',
  'LINCE',
  'LINCO',
  'LINDA',
  'LINDE',
  'LINDO',
  'LINFA',
  'LINGA',
  'LINHA',
  'LINHO',
  'LIRAS',
  'LISAS',
  'LISMA',
  'LISMO',
  'LISOL',
  'LISOS',
  'LISSA',
  'LISTA',
  'LISTE',
  'LISTO',
  'LITAR',
  'LITOR',
  'LITRO',
  'LITÃO',
  'LIVEL',
  'LIVOR',
  'LIVRA',
  'LIVRE',
  'LIVRO',
  'LIXAM',
  'LIXAR',
  'LIXAS',
  'LIXEI',
  'LIXEM',
  'LIXES',
  'LIXOS',
  'LIXOU',
  'LIXÃO',
  'LIZAR',
  'LIÇÃO',
  'LOBAL',
  'LOBAR',
  'LOBAS',
  'LOBBY',
  'LOBOS',
  'LOBÃO',
  'LOCAI',
  'LOCAL',
  'LOCAM',
  'LOCAR',
  'LOCAS',
  'LOCOU',
  'LODOS',
  'LOGAR',
  'LOGIN',
  'LOGON',
  'LOGOS',
  'LOGRA',
  'LOGRE',
  'LOGRO',
  'LOGUE',
  'LOIRA',
  'LOIRO',
  'LOISA',
  'LOIÇA',
  'LOJAS',
  'LOMBA',
  'LOMBO',
  'LONAS',
  'LONCA',
  'LONDO',
  'LONGA',
  'LONGE',
  'LONGO',
  'LONJA',
  'LOPES',
  'LOQUE',
  'LORAL',
  'LORCA',
  'LORDA',
  'LORDE',
  'LORGA',
  'LOROS',
  'LORPA',
  'LORTO',
  'LOSNA',
  'LOTAM',
  'LOTAR',
  'LOTAS',
  'LOTEI',
  'LOTEM',
  'LOTES',
  'LOTEÁ',
  'LOTOS',
  'LOTOU',
  'LOUCA',
  'LOUCO',
  'LOURA',
  'LOURO',
  'LOUSA',
  'LOUVA',
  'LOUVE',
  'LOUVO',
  'LOÇÃO',
  'LUANA',
  'LUANE',
  'LUANO',
  'LUCAS',
  'LUCHO',
  'LUCHÃ',
  'LUCRA',
  'LUCRE',
  'LUCRO',
  'LUCÃO',
  'LUDAR',
  'LUENA',
  'LUFAR',
  'LUGAR',
  'LUGOL',
  'LUGRE',
  'LUITA',
  'LULAS',
  'LULUS',
  'LULÃO',
  'LUMBO',
  'LUMEN',
  'LUMES',
  'LUMIA',
  'LUNAR',
  'LUNDA',
  'LUNDU',
  'LUNGA',
  'LUNGO',
  'LUPAS',
  'LUQUE',
  'LURAR',
  'LUSAS',
  'LUSCO',
  'LUSOS',
  'LUTAI',
  'LUTAM',
  'LUTAR',
  'LUTAS',
  'LUTEI',
  'LUTEM',
  'LUTES',
  'LUTOS',
  'LUTOU',
  'LUTRA',
  'LUVAR',
  'LUVAS',
  'LUXAR',
  'LUXOS',
  'LUZAS',
  'LUZEM',
  'LUZES',
  'LUZIA',
  'LUZIO',
  'LUZIR',
  'LUZIS',
  'LUZIU',
  'LVIII',
  'LXIII',
  'LXVII',
  'LXXII',
  'LXXIV',
  'LXXIX',
  'LXXVI',
  'LXXXI',
  'LXXXV',
  'LYCRA',
  'LÁBEO',
  'LÁBIA',
  'LÁBIL',
  'LÁBIO',
  'LÁCIO',
  'LÁCON',
  'LÁJEA',
  'LÁPIS',
  'LÁRIA',
  'LÁRIX',
  'LÁTEX',
  'LÂMIA',
  'LÂNIO',
  'LÉGUA',
  'LÉLIA',
  'LÉXIS',
  'LÊMUR',
  'LÍBER',
  'LÍBIO',
  'LÍCIA',
  'LÍCIO',
  'LÍDER',
  'LÍDIO',
  'LÍGIO',
  'LÍNEO',
  'LÍRIA',
  'LÍRIO',
  'LÍTIO',
  'LÍVIA',
  'LÓCUS',
  'LÓDÃO',
  'LÓLIO',
  'LÓRIS',
  'LÓTUS',
  'LÚCIO',
  'LÚDIO',
  'LÚPIA',
  'LÚPUS',
  'LÚRIA',
  'LÚTEO',
  'MAARI',
  'MABER',
  'MACAU',
  'MACAÁ',
  'MACAÉ',
  'MACHA',
  'MACHO',
  'MACHÊ',
  'MACIA',
  'MACIO',
  'MACIS',
  'MACIÉ',
  'MACLA',
  'MACRO',
  'MACUA',
  'MADRE',
  'MAFRA',
  'MAFUA',
  'MAGAL',
  'MAGDA',
  'MAGIA',
  'MAGMA',
  'MAGNA',
  'MAGNO',
  'MAGNÉ',
  'MAGOE',
  'MAGOO',
  'MAGOS',
  'MAGRA',
  'MAGRO',
  'MAHDI',
  'MAIAR',
  'MAIAS',
  'MAINO',
  'MAINÁ',
  'MAIOR',
  'MAIOS',
  'MAIRE',
  'MAITA',
  'MAIÃO',
  'MAJOR',
  'MALAR',
  'MALAS',
  'MALES',
  'MALGA',
  'MALHA',
  'MALHE',
  'MALHO',
  'MALTA',
  'MALTE',
  'MALVA',
  'MALVO',
  'MAMAI',
  'MAMAL',
  'MAMAM',
  'MAMAR',
  'MAMAS',
  'MAMBA',
  'MAMBO',
  'MAMEI',
  'MAMEM',
  'MAMES',
  'MAMOA',
  'MAMOU',
  'MAMÃE',
  'MAMÃO',
  'MANAR',
  'MANAS',
  'MANAU',
  'MANAÍ',
  'MANCA',
  'MANCO',
  'MANDA',
  'MANDE',
  'MANDI',
  'MANDO',
  'MANDU',
  'MANEL',
  'MANES',
  'MANEÁ',
  'MANGA',
  'MANGO',
  'MANGU',
  'MANHO',
  'MANHÃ',
  'MANIA',
  'MANIR',
  'MANJA',
  'MANJE',
  'MANJO',
  'MANJU',
  'MANOS',
  'MANSA',
  'MANSO',
  'MANTA',
  'MANTO',
  'MANTÊ',
  'MANUA',
  'MANUL',
  'MANUÊ',
  'MAONA',
  'MAORI',
  'MAPAS',
  'MAPEÁ',
  'MAPLE',
  'MAPUÁ',
  'MAPÃO',
  'MAQUE',
  'MAQUI',
  'MARAR',
  'MARAU',
  'MARCA',
  'MARCO',
  'MARDO',
  'MAREL',
  'MARES',
  'MARGA',
  'MARGO',
  'MARIA',
  'MARIM',
  'MARJA',
  'MARMA',
  'MARMO',
  'MARNA',
  'MARNO',
  'MARRA',
  'MARSO',
  'MARTA',
  'MARTE',
  'MARTO',
  'MARUÁ',
  'MARUÍ',
  'MARÃO',
  'MASCA',
  'MASCO',
  'MASER',
  'MASEU',
  'MASSA',
  'MASTO',
  'MATAI',
  'MATAL',
  'MATAM',
  'MATAR',
  'MATAS',
  'MATAU',
  'MATCH',
  'MATEI',
  'MATEM',
  'MATES',
  'MATIA',
  'MATIS',
  'MATIZ',
  'MATOS',
  'MATOU',
  'MATÃO',
  'MATÉU',
  'MAULA',
  'MAURA',
  'MAURO',
  'MAUÉS',
  'MAXIM',
  'MAZAR',
  'MAÇAL',
  'MAÇAR',
  'MAÇOM',
  'MAÇOS',
  'MAÇÃO',
  'MAÇÃS',
  'MAÍRA',
  'MAÍÇA',
  'MCMXC',
  'MEADA',
  'MEADO',
  'MEATO',
  'MECHA',
  'MEDEM',
  'MEDES',
  'MEDIR',
  'MEDIS',
  'MEDIU',
  'MEDOS',
  'MEDRA',
  'MEDRE',
  'MEDRO',
  'MEIAS',
  'MEIGA',
  'MEIGO',
  'MEIOS',
  'MEIRI',
  'MEIÃO',
  'MELAM',
  'MELAR',
  'MELAS',
  'MELBA',
  'MELCA',
  'MELEI',
  'MELEM',
  'MELES',
  'MELGA',
  'MELHÃ',
  'MELOA',
  'MELOU',
  'MELRA',
  'MELRO',
  'MELÃO',
  'MENAS',
  'MENDE',
  'MENDI',
  'MENDO',
  'MENGA',
  'MENGO',
  'MENHA',
  'MENIA',
  'MENIR',
  'MENOR',
  'MENOS',
  'MENSA',
  'MENSO',
  'MENTA',
  'MENTE',
  'MENTI',
  'MENTO',
  'MENUS',
  'MENÊS',
  'MERAS',
  'MERCA',
  'MERCÊ',
  'MERDA',
  'MERIM',
  'MERIÓ',
  'MERLO',
  'MERMA',
  'MEROS',
  'MERUA',
  'MESAS',
  'MESES',
  'MESMA',
  'MESMO',
  'MESNA',
  'MESSE',
  'MESTO',
  'MESÃO',
  'METAL',
  'METAM',
  'METAS',
  'METEI',
  'METEM',
  'METER',
  'METES',
  'METEU',
  'METIA',
  'METIL',
  'METIM',
  'METIÊ',
  'METOL',
  'METRO',
  'MEUDO',
  'MEXAM',
  'MEXAS',
  'MEXEI',
  'MEXEM',
  'MEXER',
  'MEXES',
  'MEXEU',
  'MEXIA',
  'MEZZO',
  'MEÇAM',
  'MEÇAS',
  'MIADA',
  'MIADO',
  'MIAIS',
  'MIANA',
  'MIARA',
  'MIAVA',
  'MICAR',
  'MICAS',
  'MICHA',
  'MICHO',
  'MICHÊ',
  'MICOS',
  'MICRA',
  'MICRO',
  'MIDAS',
  'MIDEU',
  'MIELO',
  'MIGAR',
  'MIGAS',
  'MIGRA',
  'MIGRE',
  'MIGRO',
  'MIINA',
  'MIJAM',
  'MIJAR',
  'MIJAS',
  'MIJEI',
  'MIJEM',
  'MIJOS',
  'MIJOU',
  'MIJÃO',
  'MILDE',
  'MILEU',
  'MILHA',
  'MILHO',
  'MILPA',
  'MIMAM',
  'MIMAR',
  'MIMAS',
  'MIMBO',
  'MIMEI',
  'MIMEM',
  'MIMES',
  'MIMOS',
  'MIMOU',
  'MINAM',
  'MINAR',
  'MINAS',
  'MINAZ',
  'MINDÁ',
  'MINEI',
  'MINEM',
  'MINES',
  'MINEU',
  'MINGA',
  'MINGO',
  'MINHA',
  'MINIS',
  'MINOR',
  'MINOU',
  'MINTA',
  'MINTO',
  'MIOLO',
  'MIOMA',
  'MIOSE',
  'MIOTO',
  'MIQUE',
  'MIRAI',
  'MIRAM',
  'MIRAR',
  'MIRAS',
  'MIREI',
  'MIREM',
  'MIRES',
  'MIRIM',
  'MIRMO',
  'MIROU',
  'MIRRA',
  'MIRRO',
  'MIRTO',
  'MIRZÁ',
  'MIRÃO',
  'MISNÁ',
  'MISSA',
  'MISSE',
  'MISSÔ',
  'MISTA',
  'MISTE',
  'MISTO',
  'MITES',
  'MITIS',
  'MITOS',
  'MITRA',
  'MITRO',
  'MIXAR',
  'MIXOS',
  'MIXTO',
  'MIÚDA',
  'MIÚDE',
  'MIÚDO',
  'MIÚFA',
  'MIÚRA',
  'MMVII',
  'MMXII',
  'MMXIV',
  'MMXVI',
  'MOABI',
  'MOAIS',
  'MOCAR',
  'MOCHA',
  'MOCHE',
  'MOCHI',
  'MOCHO',
  'MODAL',
  'MODAS',
  'MODEM',
  'MODOS',
  'MODUS',
  'MOEDA',
  'MOEGA',
  'MOEIS',
  'MOELA',
  'MOERA',
  'MOFAM',
  'MOFAR',
  'MOFAS',
  'MOFEI',
  'MOFEM',
  'MOFOS',
  'MOFOU',
  'MOGNO',
  'MOGOL',
  'MOINA',
  'MOIRA',
  'MOIRO',
  'MOIRÉ',
  'MOITA',
  'MOJAR',
  'MOLAL',
  'MOLAR',
  'MOLAS',
  'MOLDA',
  'MOLDE',
  'MOLDO',
  'MOLES',
  'MOLHA',
  'MOLHE',
  'MOLHO',
  'MOLIM',
  'MOMOS',
  'MONAS',
  'MONCO',
  'MONDA',
  'MONDO',
  'MONDÉ',
  'MONEL',
  'MONGE',
  'MONGO',
  'MONHA',
  'MONHO',
  'MONHÉ',
  'MONIR',
  'MONJA',
  'MONOS',
  'MONSO',
  'MONTA',
  'MONTE',
  'MONTO',
  'MOQUE',
  'MORAI',
  'MORAL',
  'MORAM',
  'MORAR',
  'MORAS',
  'MORBO',
  'MORDA',
  'MORDE',
  'MORDI',
  'MORDO',
  'MOREI',
  'MOREM',
  'MORES',
  'MORFE',
  'MORFO',
  'MORIA',
  'MORIM',
  'MORMO',
  'MORNA',
  'MORNO',
  'MOROU',
  'MORRA',
  'MORRE',
  'MORRI',
  'MORRO',
  'MORSA',
  'MORSE',
  'MORSO',
  'MORTA',
  'MORTE',
  'MORTO',
  'MORÃO',
  'MOSCA',
  'MOSCO',
  'MOSSA',
  'MOSSI',
  'MOSTO',
  'MOTAR',
  'MOTEL',
  'MOTIM',
  'MOTOR',
  'MOTOS',
  'MOUCO',
  'MOULE',
  'MOURA',
  'MOURO',
  'MOUSE',
  'MOUTA',
  'MOUXE',
  'MOVAM',
  'MOVAS',
  'MOVEI',
  'MOVEM',
  'MOVER',
  'MOVES',
  'MOVEU',
  'MOVIA',
  'MOXAR',
  'MOÁDI',
  'MOÇAS',
  'MOÇOS',
  'MOÇÃO',
  'MOÍAM',
  'MOÍDA',
  'MOÍDO',
  'MUANA',
  'MUATA',
  'MUCHE',
  'MUCIA',
  'MUCOS',
  'MUDAI',
  'MUDAM',
  'MUDAR',
  'MUDAS',
  'MUDEI',
  'MUDEM',
  'MUDES',
  'MUDEZ',
  'MUDOS',
  'MUDOU',
  'MUDRA',
  'MUELA',
  'MUELE',
  'MUENE',
  'MUERE',
  'MUFLA',
  'MUFTI',
  'MUGEM',
  'MUGIA',
  'MUGIR',
  'MUGIU',
  'MUGRE',
  'MUIRÁ',
  'MUITA',
  'MUITO',
  'MULAS',
  'MULIM',
  'MULTA',
  'MULTE',
  'MULTI',
  'MULTO',
  'MUMBO',
  'MUNDA',
  'MUNDO',
  'MUNDÉ',
  'MUNEM',
  'MUNGA',
  'MUNGO',
  'MUNGU',
  'MUNHA',
  'MUNHO',
  'MUNIA',
  'MUNIR',
  'MUNIS',
  'MUNIU',
  'MUNTO',
  'MUQUE',
  'MURAI',
  'MURAL',
  'MURAM',
  'MURAR',
  'MURAS',
  'MURES',
  'MUROS',
  'MUROU',
  'MURRA',
  'MURRO',
  'MURTA',
  'MURUA',
  'MURZÁ',
  'MURÇA',
  'MUSAL',
  'MUSAS',
  'MUSCA',
  'MUSCO',
  'MUSEU',
  'MUSGO',
  'MUSMÉ',
  'MUSSE',
  'MUSTO',
  'MUTIA',
  'MUTOA',
  'MUTRA',
  'MUTUM',
  'MUÇUM',
  'MUÇÃO',
  'MXIII',
  'MÁCEA',
  'MÁDIA',
  'MÁFIA',
  'MÁGIS',
  'MÁGOA',
  'MÁLUS',
  'MÁSEO',
  'MÁTRI',
  'MÁVIA',
  'MÉCIA',
  'MÉDIA',
  'MÉDIO',
  'MÉDÃO',
  'MÉLIA',
  'MÉSIO',
  'MÉSON',
  'MÍCIO',
  'MÍDIA',
  'MÍLEO',
  'MÍNIO',
  'MÍOPE',
  'MÍRIS',
  'MÓBIL',
  'MÓDIO',
  'MÓVEL',
  'MÚCHI',
  'MÚCUA',
  'MÚMIA',
  'MÚNDI',
  'MÚNUS',
  'MÚRIA',
  'MÚTUA',
  'MÚTUO',
  'NABAL',
  'NABLA',
  'NABOS',
  'NACOS',
  'NACRE',
  'NADAI',
  'NADAL',
  'NADAM',
  'NADAR',
  'NADAS',
  'NADEI',
  'NADEM',
  'NADES',
  'NADIM',
  'NADIR',
  'NADOS',
  'NADOU',
  'NAFIL',
  'NAFTA',
  'NAGAR',
  'NAGER',
  'NAGÃO',
  'NAIDE',
  'NAIFA',
  'NAIFE',
  'NAIPE',
  'NAIRA',
  'NAIRE',
  'NAIRO',
  'NALGA',
  'NALGO',
  'NAMAZ',
  'NAMBI',
  'NAMBU',
  'NANAI',
  'NANAL',
  'NANAM',
  'NANAR',
  'NANAS',
  'NANDI',
  'NANDO',
  'NANDU',
  'NANES',
  'NANGA',
  'NANJA',
  'NANOU',
  'NAQUE',
  'NARCO',
  'NARDO',
  'NARGO',
  'NARIO',
  'NARIZ',
  'NARRA',
  'NARRE',
  'NARRO',
  'NARTE',
  'NASAL',
  'NASCE',
  'NASCI',
  'NASSA',
  'NASSE',
  'NASSO',
  'NASÇA',
  'NASÇO',
  'NATAL',
  'NATAS',
  'NATIO',
  'NATOS',
  'NATRO',
  'NAURO',
  'NAUTA',
  'NAVAL',
  'NAVES',
  'NAVIO',
  'NAÇÃO',
  'NAÏVE',
  'NECRA',
  'NECRO',
  'NEDUM',
  'NEERA',
  'NEFAS',
  'NEFRO',
  'NEGAI',
  'NEGAM',
  'NEGAR',
  'NEGAS',
  'NEGOU',
  'NEGRA',
  'NEGRO',
  'NEGUE',
  'NEGUS',
  'NEGÃO',
  'NELAS',
  'NELES',
  'NELMA',
  'NEMEU',
  'NENGO',
  'NENHO',
  'NENTE',
  'NENÉM',
  'NENÊS',
  'NEPOS',
  'NEQUE',
  'NERAL',
  'NERES',
  'NEROL',
  'NERVO',
  'NESGA',
  'NESSA',
  'NESSE',
  'NESTA',
  'NESTE',
  'NESTO',
  'NETAS',
  'NETOS',
  'NEUMA',
  'NEURA',
  'NEURI',
  'NEURO',
  'NEVAM',
  'NEVAR',
  'NEVEM',
  'NEVOU',
  'NEVÃO',
  'NEXOS',
  'NGANA',
  'NGOLA',
  'NHACA',
  'NHOCA',
  'NICAR',
  'NICAS',
  'NICHO',
  'NICOL',
  'NICÊS',
  'NIDAR',
  'NIGRA',
  'NIMAS',
  'NIMBO',
  'NINAM',
  'NINAR',
  'NINAS',
  'NINEI',
  'NINES',
  'NINFA',
  'NINGA',
  'NINHO',
  'NINJA',
  'NINOU',
  'NIPLE',
  'NIQUE',
  'NISEI',
  'NISSO',
  'NISTO',
  'NITAL',
  'NITRO',
  'NIVAL',
  'NOBEL',
  'NOBRE',
  'NODAL',
  'NODAR',
  'NODOS',
  'NOEMA',
  'NOESE',
  'NOETE',
  'NOGAI',
  'NOGAL',
  'NOISE',
  'NOITE',
  'NOIVA',
  'NOIVE',
  'NOIVO',
  'NOJOS',
  'NOMES',
  'NOMEÁ',
  'NOMIA',
  'NONAS',
  'NONDE',
  'NONES',
  'NOPAL',
  'NOQUE',
  'NORAS',
  'NORBU',
  'NORMA',
  'NORNA',
  'NORTE',
  'NOSSA',
  'NOSSO',
  'NOTAI',
  'NOTAL',
  'NOTAM',
  'NOTAR',
  'NOTAS',
  'NOTEI',
  'NOTEM',
  'NOTES',
  'NOTOU',
  'NOTRO',
  'NOUTE',
  'NOVAL',
  'NOVAR',
  'NOVAS',
  'NOVEL',
  'NOVOS',
  'NOZES',
  'NOÇÃO',
  'NUCAL',
  'NUDEZ',
  'NUJOL',
  'NULAS',
  'NULOS',
  'NUMAS',
  'NUNCA',
  'NUNCE',
  'NUNDO',
  'NUNES',
  'NUTRA',
  'NUTRE',
  'NUTRI',
  'NUTRO',
  'NUTUM',
  'NUVEM',
  'NUÇÃO',
  'NYLON',
  'NÁBIS',
  'NÁBÃO',
  'NÁCAR',
  'NÁGUA',
  'NÁREA',
  'NÁSIO',
  'NÁSSI',
  'NÁSUA',
  'NÁTIA',
  'NÁVEA',
  'NÁVIA',
  'NÁXIA',
  'NÁZIA',
  'NÁZIR',
  'NÉBEL',
  'NÉDIO',
  'NÉLIA',
  'NÉONE',
  'NÉPER',
  'NÉPIA',
  'NÉRIO',
  'NÉVOA',
  'NÊNIA',
  'NÍGER',
  'NÍMIO',
  'NÍSIO',
  'NÍVEL',
  'NÍVEO',
  'NÓDOA',
  'NÓMOS',
  'NÓRIA',
  'NÓRIO',
  'NÔNIO',
  'NÚBIA',
  'NÚBIL',
  'NÚBIO',
  'NÚMEN',
  'NÚRIA',
  'OANDA',
  'OBESA',
  'OBESO',
  'OBORI',
  'OBRAR',
  'OBRAS',
  'OBSTA',
  'OBSTE',
  'OBTER',
  'OBTÉM',
  'OCADO',
  'OCAPI',
  'OCARA',
  'OCASO',
  'OCELO',
  'OCTAL',
  'OCTIL',
  'OCUPA',
  'OCUPE',
  'OCUPO',
  'ODARA',
  'ODEDÉ',
  'ODEIA',
  'ODEIE',
  'ODEIO',
  'ODEÃO',
  'ODIAI',
  'ODIAR',
  'ODIEI',
  'ODILA',
  'ODIOU',
  'ODONE',
  'ODORO',
  'ODÉON',
  'OESTE',
  'OFAIÉ',
  'OFATO',
  'OFEGO',
  'OFITA',
  'OGIVA',
  'OGONI',
  'OIROS',
  'OITÃO',
  'OIÇAM',
  'OLADA',
  'OLAIA',
  'OLALÁ',
  'OLARÉ',
  'OLEAR',
  'OLHAI',
  'OLHAL',
  'OLHAM',
  'OLHAR',
  'OLHAS',
  'OLHEI',
  'OLHEM',
  'OLHES',
  'OLHOS',
  'OLHOU',
  'OLHÃO',
  'OLIGO',
  'OLINA',
  'OLIVA',
  'OLMOS',
  'OLOCO',
  'OMAHA',
  'OMALÁ',
  'OMANI',
  'OMANO',
  'OMASO',
  'OMBRO',
  'OMBRÃ',
  'OMIRI',
  'OMITA',
  'OMITE',
  'OMITI',
  'OMITO',
  'OMOLU',
  'ONAGA',
  'ONDAR',
  'ONDAS',
  'ONDEÁ',
  'ONERA',
  'ONERE',
  'ONGUE',
  'ONICO',
  'ONTEM',
  'ONÇAS',
  'OPACA',
  'OPACO',
  'OPADO',
  'OPALA',
  'OPELÉ',
  'OPERA',
  'OPERE',
  'OPERO',
  'OPIAR',
  'OPIMO',
  'OPINA',
  'OPINE',
  'OPINO',
  'OPORÁ',
  'OPTAM',
  'OPTAR',
  'OPTAS',
  'OPTEI',
  'OPTEM',
  'OPTES',
  'OPTOU',
  'OPÇÃO',
  'OPÕEM',
  'OPÕES',
  'ORACA',
  'ORADA',
  'ORADO',
  'ORAGO',
  'ORAIS',
  'ORARA',
  'ORATE',
  'ORAVA',
  'ORCAS',
  'ORCEI',
  'ORDEM',
  'OREIS',
  'ORELA',
  'ORGIA',
  'ORICA',
  'ORITE',
  'ORIXÁ',
  'ORIZA',
  'ORLAM',
  'ORLAR',
  'ORLAS',
  'ORLEI',
  'ORLON',
  'ORNAM',
  'ORNAR',
  'ORNEI',
  'ORNEM',
  'ORNIS',
  'ORNOU',
  'OROBÓ',
  'OROMO',
  'OROPA',
  'ORQUE',
  'ORQUI',
  'ORÇAM',
  'ORÇAR',
  'ORÇOU',
  'OSANA',
  'OSCAR',
  'OSLER',
  'OSSOS',
  'OSTEO',
  'OSTRA',
  'OSTRO',
  'OTECA',
  'OTELO',
  'OTINA',
  'OTITE',
  'OTOMI',
  'OTONA',
  'OTONI',
  'OUGAR',
  'OURAR',
  'OUROS',
  'OURÉM',
  'OUSAI',
  'OUSAM',
  'OUSAR',
  'OUSAS',
  'OUSEI',
  'OUSEM',
  'OUSES',
  'OUSIA',
  'OUSIO',
  'OUSOU',
  'OUTAR',
  'OUTRA',
  'OUTRO',
  'OUTÃO',
  'OUVEM',
  'OUVES',
  'OUVIA',
  'OUVIR',
  'OUVIS',
  'OUVIU',
  'OUÇAM',
  'OUÇAS',
  'OUÇÃO',
  'OVADA',
  'OVADO',
  'OVAIS',
  'OVINO',
  'OXALÁ',
  'OXIDA',
  'OXIDE',
  'OXILO',
  'OXIMA',
  'OXINA',
  'OZENA',
  'OZONE',
  'OZONO',
  'OÁSIS',
  'OÍDIO',
  'PACAS',
  'PACAU',
  'PACHO',
  'PACHÃ',
  'PACÃO',
  'PADMA',
  'PADRE',
  'PADÊS',
  'PAETÊ',
  'PAGAI',
  'PAGAM',
  'PAGAR',
  'PAGAS',
  'PAGEL',
  'PAGEM',
  'PAGER',
  'PAGEU',
  'PAGOS',
  'PAGOU',
  'PAGUE',
  'PAGÃO',
  'PAICA',
  'PAIGC',
  'PAINA',
  'PAIOL',
  'PAIRA',
  'PAIRE',
  'PAIRO',
  'PAIVO',
  'PAIXA',
  'PAIÃO',
  'PAJEM',
  'PAJEÚ',
  'PAJÉS',
  'PALAR',
  'PALAU',
  'PALCO',
  'PALEO',
  'PALHA',
  'PALIO',
  'PALMA',
  'PALMO',
  'PALOR',
  'PALOS',
  'PALPO',
  'PALRA',
  'PALÃO',
  'PAMPA',
  'PAMPO',
  'PANAL',
  'PANAR',
  'PANCA',
  'PANCO',
  'PANDA',
  'PANDO',
  'PANGA',
  'PANGO',
  'PANHE',
  'PANOS',
  'PANTA',
  'PANTÓ',
  'PANÃO',
  'PAPAI',
  'PAPAL',
  'PAPAM',
  'PAPAR',
  'PAPAS',
  'PAPEI',
  'PAPEL',
  'PAPEM',
  'PAPES',
  'PAPOS',
  'PAPOU',
  'PAPUA',
  'PAPUS',
  'PAPÃO',
  'PAQUI',
  'PAQUÊ',
  'PARAI',
  'PARAL',
  'PARAM',
  'PARAR',
  'PARAS',
  'PARAU',
  'PARBA',
  'PARCA',
  'PARCO',
  'PARDA',
  'PARDO',
  'PAREI',
  'PAREM',
  'PARES',
  'PARGA',
  'PARGO',
  'PARIA',
  'PARIR',
  'PARIS',
  'PARIU',
  'PARLA',
  'PARMA',
  'PARNO',
  'PAROL',
  'PAROU',
  'PARRA',
  'PARRO',
  'PARSE',
  'PARTA',
  'PARTE',
  'PARTI',
  'PARTO',
  'PARUM',
  'PARVA',
  'PARVI',
  'PARVO',
  'PARÃO',
  'PASEP',
  'PASMA',
  'PASME',
  'PASMO',
  'PASSA',
  'PASSE',
  'PASSO',
  'PASTA',
  'PASTE',
  'PASTO',
  'PATAS',
  'PATAU',
  'PATAÍ',
  'PATEL',
  'PATIM',
  'PATIÁ',
  'PATOS',
  'PATOÁ',
  'PATUÁ',
  'PATÃO',
  'PATÉM',
  'PAUDA',
  'PAUIS',
  'PAULA',
  'PAULO',
  'PAUSA',
  'PAUTA',
  'PAUTE',
  'PAUTO',
  'PAVIA',
  'PAVIO',
  'PAVOA',
  'PAVOR',
  'PAVÃO',
  'PAVÊS',
  'PAZES',
  'PAÇOS',
  'PAÚRA',
  'PCDOB',
  'PEADO',
  'PEALO',
  'PEANA',
  'PECAI',
  'PECAR',
  'PECHA',
  'PECOU',
  'PECÉM',
  'PEDAL',
  'PEDEM',
  'PEDES',
  'PEDIA',
  'PEDIR',
  'PEDIS',
  'PEDIU',
  'PEDRA',
  'PEGAI',
  'PEGAM',
  'PEGAR',
  'PEGAS',
  'PEGOL',
  'PEGOS',
  'PEGOU',
  'PEGUE',
  'PEGÃO',
  'PEIAS',
  'PEIDA',
  'PEIDE',
  'PEIDO',
  'PEINA',
  'PEITA',
  'PEITE',
  'PEITO',
  'PEIXE',
  'PEJAR',
  'PEJOS',
  'PELAI',
  'PELAM',
  'PELAR',
  'PELAS',
  'PELEI',
  'PELES',
  'PELIA',
  'PELOR',
  'PELOS',
  'PELOU',
  'PELTA',
  'PELVE',
  'PELÃO',
  'PELÉM',
  'PEMBA',
  'PENAI',
  'PENAL',
  'PENAM',
  'PENAR',
  'PENAS',
  'PENCA',
  'PENCE',
  'PENCO',
  'PENDA',
  'PENDE',
  'PENDI',
  'PENDO',
  'PENEI',
  'PENEM',
  'PENES',
  'PENHA',
  'PENIA',
  'PENOU',
  'PENSA',
  'PENSE',
  'PENSO',
  'PENTA',
  'PENTE',
  'PENÃO',
  'PEONA',
  'PEPEL',
  'PEPLO',
  'PEPÉS',
  'PEQUE',
  'PEQUI',
  'PERAL',
  'PERAS',
  'PERAU',
  'PERCA',
  'PERCE',
  'PERCO',
  'PERDA',
  'PERDE',
  'PERDI',
  'PEREÁ',
  'PERLA',
  'PERNA',
  'PERNO',
  'PERNÉ',
  'PEROÁ',
  'PERRA',
  'PERRO',
  'PERSA',
  'PERTO',
  'PERUA',
  'PERUS',
  'PESAI',
  'PESAM',
  'PESAR',
  'PESAS',
  'PESCA',
  'PESCO',
  'PESEI',
  'PESEM',
  'PESES',
  'PESOS',
  'PESOU',
  'PESSE',
  'PESTE',
  'PESÃO',
  'PETAL',
  'PETAR',
  'PETAS',
  'PETIZ',
  'PETIÁ',
  'PETRA',
  'PETÉM',
  'PEXIA',
  'PEXIM',
  'PEZÃO',
  'PEÇAM',
  'PEÇAS',
  'PEÕES',
  'PEÚGA',
  'PEÚVA',
  'PIABA',
  'PIADA',
  'PIADO',
  'PIAGA',
  'PIALO',
  'PIANA',
  'PIANO',
  'PIARA',
  'PIAUS',
  'PIAUÍ',
  'PIAVA',
  'PIAÇÁ',
  'PICAL',
  'PICAM',
  'PICAR',
  'PICAS',
  'PICAÚ',
  'PICHA',
  'PICHE',
  'PICHI',
  'PICHO',
  'PICLE',
  'PICOS',
  'PICOU',
  'PICTO',
  'PICUM',
  'PICUÁ',
  'PICUÍ',
  'PICÃO',
  'PIDÃO',
  'PIELA',
  'PIELO',
  'PIEZO',
  'PIFAM',
  'PIFAR',
  'PIFAS',
  'PIFEI',
  'PIFES',
  'PIFOU',
  'PIFÃO',
  'PIGAR',
  'PIGMA',
  'PILAR',
  'PILAU',
  'PILHA',
  'PILHE',
  'PILHO',
  'PILIM',
  'PILÃO',
  'PIMBA',
  'PINAR',
  'PINAS',
  'PINCE',
  'PINDA',
  'PINDÓ',
  'PINEL',
  'PINGA',
  'PINGO',
  'PINHA',
  'PINHO',
  'PINHÉ',
  'PINOS',
  'PINTA',
  'PINTE',
  'PINTO',
  'PINÇA',
  'PINÇO',
  'PINÉU',
  'PIOCA',
  'PIOLA',
  'PIORA',
  'PIORE',
  'PIORÓ',
  'PIPAL',
  'PIPAR',
  'PIPAS',
  'PIPIA',
  'PIPRA',
  'PIPÃO',
  'PIQUE',
  'PIQUI',
  'PIRAR',
  'PIRAÍ',
  'PIRCA',
  'PIRES',
  'PIREI',
  'PIREU',
  'PIREX',
  'PIRIA',
  'PIRIZ',
  'PIROU',
  'PIRUÁ',
  'PIRÃO',
  'PISAI',
  'PISAM',
  'PISAR',
  'PISAS',
  'PISCA',
  'PISCO',
  'PISEI',
  'PISEM',
  'PISES',
  'PISOS',
  'PISOU',
  'PISSA',
  'PISTA',
  'PISÃO',
  'PITAR',
  'PITAS',
  'PITIÚ',
  'PITOS',
  'PITUÃ',
  'PITÃO',
  'PITÉU',
  'PIVÔS',
  'PIXEL',
  'PIZZA',
  'PIÕES',
  'PIÚVA',
  'PLACA',
  'PLACÊ',
  'PLAGA',
  'PLANA',
  'PLANE',
  'PLANI',
  'PLANO',
  'PLATÔ',
  'PLEBE',
  'PLENA',
  'PLENO',
  'PLEXO',
  'PLICA',
  'PLOMO',
  'PLOTA',
  'PLOTE',
  'PLOTO',
  'PLUGA',
  'PLUGE',
  'PLUGO',
  'PLUMA',
  'PLUMO',
  'PLURI',
  'PLUSH',
  'PLUTO',
  'PNEUS',
  'POAIA',
  'POBRE',
  'POCAR',
  'POCHE',
  'POCHO',
  'PODAI',
  'PODAL',
  'PODAM',
  'PODAR',
  'PODAS',
  'PODEI',
  'PODEM',
  'PODER',
  'PODES',
  'PODIA',
  'PODOA',
  'PODOU',
  'PODRE',
  'PODÃO',
  'POEJO',
  'POEMA',
  'POETA',
  'POIAL',
  'POIAR',
  'POIOS',
  'POISA',
  'POISE',
  'POISO',
  'POITA',
  'POLAR',
  'POLCA',
  'POLDO',
  'POLEM',
  'POLEÁ',
  'POLHA',
  'POLHO',
  'POLIA',
  'POLIM',
  'POLIR',
  'POLIU',
  'POLJE',
  'POLME',
  'POLOS',
  'POLPA',
  'POLPO',
  'POLUI',
  'POLVO',
  'POMAR',
  'POMBA',
  'POMBE',
  'POMBO',
  'POMES',
  'POMOS',
  'POMPA',
  'POMPO',
  'PONCÃ',
  'PONDA',
  'PONDE',
  'PONDO',
  'PONGA',
  'PONGÓ',
  'PONHA',
  'PONHO',
  'PONIS',
  'PONTA',
  'PONTE',
  'PONTO',
  'POPIÃ',
  'PORCA',
  'PORCO',
  'POREI',
  'PORES',
  'PORIA',
  'PORME',
  'PORNO',
  'POROS',
  'PORRA',
  'PORRE',
  'PORRO',
  'PORTA',
  'PORTE',
  'PORTO',
  'PORÁS',
  'PORÃO',
  'PORÉM',
  'POSAM',
  'POSAR',
  'POSAS',
  'POSCA',
  'POSEI',
  'POSEM',
  'POSES',
  'POSOU',
  'POSSA',
  'POSSE',
  'POSSO',
  'POSTA',
  'POSTE',
  'POSTO',
  'POTES',
  'POTOS',
  'POTRA',
  'POTRO',
  'POTUM',
  'POTÃO',
  'POUCA',
  'POUCO',
  'POULE',
  'POULO',
  'POUPA',
  'POUPE',
  'POUPO',
  'POUSA',
  'POUSE',
  'POUSO',
  'POUTA',
  'POVOE',
  'POVOS',
  'POVÃO',
  'POÇAS',
  'POÇOS',
  'POÇÃO',
  'PRADO',
  'PRAGA',
  'PRAIA',
  'PRAIS',
  'PRAJÁ',
  'PRAMA',
  'PRANA',
  'PRASE',
  'PRATA',
  'PRATO',
  'PRAVO',
  'PRAXE',
  'PRAZO',
  'PRAÇA',
  'PREAR',
  'PRECE',
  'PREGA',
  'PREGO',
  'PREIA',
  'PRELO',
  'PREMA',
  'PREME',
  'PREMI',
  'PREMO',
  'PRESA',
  'PRESO',
  'PRETA',
  'PRETO',
  'PREVI',
  'PREVÊ',
  'PREZA',
  'PREZE',
  'PREZO',
  'PREÇO',
  'PRIMA',
  'PRIME',
  'PRIMI',
  'PRIMO',
  'PRIOR',
  'PRIVA',
  'PRIVE',
  'PRIVO',
  'PRIÃO',
  'PROAL',
  'PROAR',
  'PROAS',
  'PROBO',
  'PROCO',
  'PROCÁ',
  'PROLE',
  'PRONO',
  'PROPÔ',
  'PROSA',
  'PROSO',
  'PROTO',
  'PROVA',
  'PROVE',
  'PROVI',
  'PROVO',
  'PRUMA',
  'PRUMO',
  'PRÍON',
  'PSICO',
  'PSOAS',
  'PSORA',
  'PTDOB',
  'PTERO',
  'PTOSE',
  'PUCHA',
  'PUCHO',
  'PUDER',
  'PUDIM',
  'PUDOR',
  'PUERA',
  'PUERI',
  'PUGNA',
  'PULAM',
  'PULAR',
  'PULAS',
  'PULEI',
  'PULEM',
  'PULES',
  'PULGA',
  'PULGO',
  'PULHA',
  'PULIM',
  'PULOS',
  'PULOU',
  'PULSA',
  'PULSE',
  'PULSO',
  'PULÃO',
  'PUMAS',
  'PUMBA',
  'PUNAM',
  'PUNAS',
  'PUNEM',
  'PUNES',
  'PUNGA',
  'PUNHA',
  'PUNHO',
  'PUNIA',
  'PUNIR',
  'PUNIS',
  'PUNIU',
  'PUPAL',
  'PUPAR',
  'PURAS',
  'PURGA',
  'PURGO',
  'PURIM',
  'PUROS',
  'PUSER',
  'PUTAS',
  'PUTOS',
  'PUXAM',
  'PUXAR',
  'PUXAS',
  'PUXEI',
  'PUXEM',
  'PUXES',
  'PUXOS',
  'PUXOU',
  'PUXÃO',
  'PUÍDO',
  'PUÍTA',
  'PÁDER',
  'PÁDOA',
  'PÁDUA',
  'PÁGUA',
  'PÁLEA',
  'PÁPIO',
  'PÁREA',
  'PÁREO',
  'PÁRIO',
  'PÁRSI',
  'PÁTEO',
  'PÁTIO',
  'PÂNUS',
  'PÉLIO',
  'PÊNIS',
  'PÍCEA',
  'PÍERO',
  'PÍFIO',
  'PÍLEO',
  'PÍPER',
  'PÍTIA',
  'PÍTIO',
  'PÍTIS',
  'PÍTON',
  'PÓDIO',
  'PÓLEN',
  'PÓLIO',
  'PÓLIS',
  'PÓLUX',
  'PÓVOA',
  'PÔNEI',
  'PÚBIS',
  'PÚGIL',
  'PÚLEX',
  'QUADO',
  'QUAGA',
  'QUAIS',
  'QUALÉ',
  'QUARA',
  'QUARK',
  'QUARÓ',
  'QUASA',
  'QUASE',
  'QUATI',
  'QUATÁ',
  'QUEBA',
  'QUECA',
  'QUECÉ',
  'QUEDA',
  'QUEDE',
  'QUEDO',
  'QUEIA',
  'QUELA',
  'QUELÉ',
  'QUEMO',
  'QUENA',
  'QUENO',
  'QUEPE',
  'QUERA',
  'QUERI',
  'QUERO',
  'QUERÊ',
  'QUETE',
  'QUETO',
  'QUEZA',
  'QUIBE',
  'QUICÉ',
  'QUIDO',
  'QUILI',
  'QUILO',
  'QUIMI',
  'QUIMO',
  'QUIMÉ',
  'QUINA',
  'QUINO',
  'QUIPO',
  'QUIPÁ',
  'QUIPÉ',
  'QUIRE',
  'QUIRI',
  'QUIRO',
  'QUITA',
  'QUITE',
  'QUITI',
  'QUITO',
  'QUIUÍ',
  'QUIVI',
  'QUIXA',
  'QUIXÓ',
  'QUIZA',
  'QUIÇO',
  'QUIÇÁ',
  'QUOTA',
  'QUÁLI',
  'QUÉPI',
  'RABAL',
  'RABEL',
  'RABIA',
  'RABOS',
  'RABÃO',
  'RACHA',
  'RACHE',
  'RACHO',
  'RACUM',
  'RADAR',
  'RADIA',
  'RADIE',
  'RADÃO',
  'RAGLÃ',
  'RAIAM',
  'RAIAR',
  'RAIAS',
  'RAIDE',
  'RAIES',
  'RAIOM',
  'RAIOS',
  'RAIOU',
  'RAIVA',
  'RAJAM',
  'RAJAR',
  'RAJAS',
  'RAJES',
  'RAJÃO',
  'RALAM',
  'RALAR',
  'RALAS',
  'RALEI',
  'RALEM',
  'RALES',
  'RALHA',
  'RALHE',
  'RALHO',
  'RALIS',
  'RALOS',
  'RALOU',
  'RAMAL',
  'RAMAR',
  'RAMAS',
  'RAMBO',
  'RAMOS',
  'RAMPA',
  'RANAL',
  'RANCA',
  'RANGE',
  'RANGI',
  'RANGO',
  'RANHA',
  'RANHO',
  'RANJA',
  'RANJO',
  'RANÇO',
  'RAPAI',
  'RAPAM',
  'RAPAR',
  'RAPAS',
  'RAPAZ',
  'RAPEI',
  'RAPEL',
  'RAPEM',
  'RAPES',
  'RAPOU',
  'RAPTA',
  'RAPTE',
  'RAPTO',
  'RAQUE',
  'RARAR',
  'RARAS',
  'RAROS',
  'RASAR',
  'RASAS',
  'RASCA',
  'RASCO',
  'RASGA',
  'RASGO',
  'RASOS',
  'RASPA',
  'RASPE',
  'RASPO',
  'RASTE',
  'RASTO',
  'RASÃO',
  'RATAR',
  'RATAS',
  'RATEL',
  'RATIM',
  'RATIO',
  'RATOS',
  'RATÃO',
  'RAZIA',
  'RAZÃO',
  'RAÇAS',
  'RAÇÃO',
  'RAÍTA',
  'REAGE',
  'REAGI',
  'REAIS',
  'REAJA',
  'REAJO',
  'REAME',
  'REATA',
  'REATE',
  'REATO',
  'REAVÊ',
  'REBAR',
  'REBOA',
  'REBÉM',
  'RECAI',
  'RECAR',
  'RECEÁ',
  'RECHÃ',
  'RECHÔ',
  'RECOS',
  'RECRU',
  'RECTA',
  'RECTO',
  'RECUA',
  'RECUE',
  'RECUO',
  'RECÃO',
  'RECÉM',
  'REDAR',
  'REDES',
  'REDIL',
  'REDOR',
  'REDOX',
  'REDRA',
  'REDUZ',
  'REDÉM',
  'REFAZ',
  'REFEZ',
  'REFIL',
  'REFIZ',
  'REFLE',
  'REFÉM',
  'REGAI',
  'REGAL',
  'REGAM',
  'REGAR',
  'REGAS',
  'REGEI',
  'REGEM',
  'REGER',
  'REGES',
  'REGEU',
  'REGOS',
  'REGOU',
  'REGRA',
  'REGRE',
  'REGRO',
  'REGUE',
  'REGÃO',
  'REICH',
  'REIDE',
  'REIMA',
  'REINA',
  'REINE',
  'REINO',
  'REIRA',
  'REIXA',
  'REJAM',
  'REJAS',
  'RELAR',
  'RELAS',
  'RELAX',
  'RELER',
  'RELES',
  'RELEU',
  'RELHA',
  'RELHO',
  'RELIA',
  'RELUZ',
  'RELVA',
  'REMAM',
  'REMAR',
  'REMAS',
  'REMEI',
  'REMEM',
  'REMES',
  'REMIA',
  'REMIR',
  'REMIS',
  'REMIU',
  'REMIX',
  'REMOA',
  'REMOO',
  'REMOS',
  'REMOU',
  'REMOÊ',
  'REMÓI',
  'RENAL',
  'RENAS',
  'RENDA',
  'RENDE',
  'RENDI',
  'RENDO',
  'RENGA',
  'RENGE',
  'RENGO',
  'RENTE',
  'RENÃO',
  'REPES',
  'REPOR',
  'REPTE',
  'REPTO',
  'REPUS',
  'REPÔS',
  'REPÕE',
  'REQUE',
  'RESES',
  'RESMA',
  'RESPE',
  'RESPO',
  'RESSA',
  'RESTA',
  'RESTE',
  'RESTO',
  'RETAL',
  'RETAR',
  'RETAS',
  'RETER',
  'RETOR',
  'RETOS',
  'RETRE',
  'RETRÔ',
  'RETÉM',
  'REUMA',
  'REUNI',
  'REVEL',
  'REVER',
  'REVEZ',
  'REVIA',
  'REVIR',
  'REVIU',
  'REVOO',
  'REVÉM',
  'REVÉS',
  'REXIO',
  'REZAI',
  'REZAM',
  'REZAR',
  'REZAS',
  'REZEI',
  'REZEM',
  'REZES',
  'REZOU',
  'REZÃO',
  'REÚNA',
  'REÚNE',
  'REÚNO',
  'REÚSO',
  'RIAIS',
  'RIANA',
  'RIBAS',
  'RIBES',
  'RICAS',
  'RICOS',
  'RICTO',
  'RICÃO',
  'RIDES',
  'RIFAM',
  'RIFAR',
  'RIFAS',
  'RIFEI',
  'RIFES',
  'RIFLE',
  'RIFOU',
  'RIFTE',
  'RIFÃO',
  'RIGOL',
  'RIGOR',
  'RIGOS',
  'RIJAS',
  'RIJOS',
  'RILHA',
  'RIMAM',
  'RIMAR',
  'RIMAS',
  'RIMEI',
  'RIMEM',
  'RIMES',
  'RIMOS',
  'RIMOU',
  'RINAL',
  'RINCO',
  'RINDO',
  'RINHA',
  'RIOJA',
  'RIPAR',
  'RIPAS',
  'RIPÃO',
  'RIQUE',
  'RIRAM',
  'RIRAS',
  'RIREI',
  'RIREM',
  'RIRES',
  'RIRIA',
  'RIRÃO',
  'RISCA',
  'RISCO',
  'RISOS',
  'RISSE',
  'RISSO',
  'RISTE',
  'RISÃO',
  'RITMO',
  'RITOS',
  'RIVAL',
  'RIXAS',
  'RIZAR',
  'RIZES',
  'RIÇAR',
  'ROAIS',
  'ROBLE',
  'ROBOT',
  'ROBÔS',
  'ROCAZ',
  'ROCEI',
  'ROCEM',
  'ROCES',
  'ROCHA',
  'ROCIM',
  'RODAL',
  'RODAM',
  'RODAR',
  'RODAS',
  'RODEI',
  'RODEL',
  'RODEM',
  'RODES',
  'RODEÁ',
  'RODOS',
  'RODOU',
  'RODÃO',
  'ROERA',
  'ROGAI',
  'ROGAM',
  'ROGAR',
  'ROGAS',
  'ROGOS',
  'ROGOU',
  'ROGUE',
  'ROJAR',
  'ROJÃO',
  'ROLAI',
  'ROLAM',
  'ROLAR',
  'ROLAS',
  'ROLDA',
  'ROLEI',
  'ROLEM',
  'ROLES',
  'ROLHA',
  'ROLHO',
  'ROLIM',
  'ROLOS',
  'ROLOU',
  'ROLÃO',
  'ROMAR',
  'ROMBO',
  'ROMEU',
  'ROMPA',
  'ROMPE',
  'ROMPI',
  'ROMPO',
  'ROMÃO',
  'ROMÃS',
  'RONCA',
  'RONCO',
  'RONDA',
  'RONDE',
  'RONDÓ',
  'RONGA',
  'RONGÓ',
  'RONHA',
  'RONTÓ',
  'ROQUE',
  'ROSAL',
  'ROSAR',
  'ROSAS',
  'ROSCA',
  'ROSES',
  'ROSNA',
  'ROSNE',
  'ROSNO',
  'ROSTI',
  'ROSTO',
  'ROSÃO',
  'ROTAR',
  'ROTAS',
  'ROTEÁ',
  'ROTIM',
  'ROTOR',
  'ROTOS',
  'ROUBA',
  'ROUBE',
  'ROUBO',
  'ROUCA',
  'ROUCO',
  'ROUGE',
  'ROUND',
  'ROUPA',
  'ROXAS',
  'ROXOS',
  'ROÇAM',
  'ROÇAR',
  'ROÇAS',
  'ROÇOU',
  'ROÍAM',
  'ROÍDA',
  'ROÍDO',
  'RUANO',
  'RUBIM',
  'RUBIS',
  'RUBLO',
  'RUBOR',
  'RUBRA',
  'RUBRO',
  'RUBÃO',
  'RUDES',
  'RUDEZ',
  'RUELA',
  'RUFAM',
  'RUFAR',
  'RUFAS',
  'RUFEM',
  'RUFIA',
  'RUFOS',
  'RUFOU',
  'RUGAI',
  'RUGAR',
  'RUGAS',
  'RUGBY',
  'RUGEM',
  'RUGES',
  'RUGIA',
  'RUGIR',
  'RUGIU',
  'RUINS',
  'RUIRÁ',
  'RUIVA',
  'RUIVO',
  'RUJAM',
  'RULAR',
  'RUMAM',
  'RUMAR',
  'RUMAS',
  'RUMBA',
  'RUMEI',
  'RUMEM',
  'RUMES',
  'RUMOR',
  'RUMOS',
  'RUMOU',
  'RUMPI',
  'RUNAS',
  'RUPIA',
  'RUPTO',
  'RURAL',
  'RUSGA',
  'RUSSA',
  'RUSSO',
  'RUÇAS',
  'RUÍAM',
  'RUÍDO',
  'RUÍNA',
  'RÁCIO',
  'RÁDIO',
  'RÁDOM',
  'RÁDON',
  'RÁFIA',
  'RÁGIO',
  'RÁPIA',
  'RÁQUI',
  'RÁTUS',
  'RÉBUS',
  'RÉCIO',
  'RÉDEA',
  'RÉDIA',
  'RÉGIA',
  'RÉGIE',
  'RÉGIO',
  'RÉGUA',
  'RÉNIO',
  'RÉVOA',
  'RÍCIO',
  'RÍGEL',
  'RÍMEL',
  'RÍPIO',
  'RÓBER',
  'RÓBUR',
  'RÓCIO',
  'RÓDIO',
  'RÓSEA',
  'RÓSEO',
  'RÚBEO',
  'RÚBIO',
  'RÚFIO',
  'RÚGBI',
  'RÚMEN',
  'SABAL',
  'SABEI',
  'SABEM',
  'SABER',
  'SABES',
  'SABEU',
  'SABIA',
  'SABIN',
  'SABIR',
  'SABLE',
  'SABOR',
  'SABRA',
  'SABRE',
  'SABÃO',
  'SACAL',
  'SACAM',
  'SACAR',
  'SACAS',
  'SACAÍ',
  'SACHA',
  'SACHO',
  'SACHÊ',
  'SACIA',
  'SACIE',
  'SACIO',
  'SACIS',
  'SACOS',
  'SACOU',
  'SACRA',
  'SACRE',
  'SACRO',
  'SACÃO',
  'SADIA',
  'SADIO',
  'SADRÁ',
  'SADÃO',
  'SAETA',
  'SAFAM',
  'SAFAR',
  'SAFAS',
  'SAFEI',
  'SAFEM',
  'SAFER',
  'SAFES',
  'SAFIO',
  'SAFOS',
  'SAFOU',
  'SAFRA',
  'SAFRE',
  'SAGAS',
  'SAGAZ',
  'SAGES',
  'SAGRA',
  'SAGRE',
  'SAGRO',
  'SAGUI',
  'SAGUM',
  'SAGUS',
  'SAGUÁ',
  'SAIAL',
  'SAIAM',
  'SAIAS',
  'SAIBA',
  'SAIBO',
  'SAICA',
  'SAIDE',
  'SAIGA',
  'SAINO',
  'SAINÉ',
  'SAIRÁ',
  'SAIRÉ',
  'SAIVÁ',
  'SAIÃO',
  'SALAS',
  'SALAZ',
  'SALDA',
  'SALDE',
  'SALDO',
  'SALGA',
  'SALGO',
  'SALMI',
  'SALMO',
  'SALPA',
  'SALSA',
  'SALSO',
  'SALTA',
  'SALTE',
  'SALTO',
  'SALVA',
  'SALVE',
  'SALVO',
  'SALÃO',
  'SALÉM',
  'SAMBA',
  'SAMBE',
  'SAMBO',
  'SAMPA',
  'SAMPÉ',
  'SAMUR',
  'SANAI',
  'SANAM',
  'SANAR',
  'SANAS',
  'SANCA',
  'SANCO',
  'SANDE',
  'SANEI',
  'SANEM',
  'SANES',
  'SANEÁ',
  'SANGA',
  'SANGO',
  'SANHA',
  'SANJA',
  'SANOU',
  'SANSA',
  'SANTA',
  'SANTO',
  'SANTÉ',
  'SAPAL',
  'SAPAR',
  'SAPES',
  'SAPIM',
  'SAPOS',
  'SAPRO',
  'SAPÃO',
  'SAQUE',
  'SAQUI',
  'SARAI',
  'SARAM',
  'SARAN',
  'SARAR',
  'SARAS',
  'SARAU',
  'SARCO',
  'SARDA',
  'SARDO',
  'SAREI',
  'SAREM',
  'SARES',
  'SARGA',
  'SARGO',
  'SARIA',
  'SARJA',
  'SARNA',
  'SAROS',
  'SAROU',
  'SARRA',
  'SARRO',
  'SARTA',
  'SARUÊ',
  'SARÃO',
  'SARÇA',
  'SASSA',
  'SAUIM',
  'SAUNA',
  'SAUPÉ',
  'SAURO',
  'SAURÁ',
  'SAVIÁ',
  'SAXÃO',
  'SAZÃO',
  'SAÍCO',
  'SAÍDA',
  'SAÍDO',
  'SAÍTA',
  'SAÚCO',
  'SAÚDA',
  'SAÚDE',
  'SAÚDO',
  'SAÚVA',
  'SCONE',
  'SCOPE',
  'SCORE',
  'SEADA',
  'SEARA',
  'SEBES',
  'SEBOS',
  'SECAL',
  'SECAM',
  'SECAR',
  'SECAS',
  'SECOS',
  'SECOU',
  'SECTA',
  'SECTO',
  'SEDAL',
  'SEDAN',
  'SEDAR',
  'SEDAS',
  'SEDES',
  'SEDIA',
  'SEDIE',
  'SEDUZ',
  'SEDÃO',
  'SEDÉM',
  'SEGAR',
  'SEGNO',
  'SEGUE',
  'SEGUI',
  'SEIOS',
  'SEIRA',
  'SEISA',
  'SEITA',
  'SEIVA',
  'SEIXA',
  'SEIXO',
  'SEIÇA',
  'SEJAM',
  'SEJAS',
  'SELAI',
  'SELAM',
  'SELAR',
  'SELAS',
  'SELEI',
  'SELEM',
  'SELES',
  'SELHA',
  'SELIM',
  'SELOS',
  'SELOU',
  'SELVA',
  'SELÃO',
  'SEMBA',
  'SEMIO',
  'SENAL',
  'SENAS',
  'SENDA',
  'SENDO',
  'SENGA',
  'SENGO',
  'SENHA',
  'SENHO',
  'SENIL',
  'SENOS',
  'SENRA',
  'SENSO',
  'SENSU',
  'SENTA',
  'SENTE',
  'SENTI',
  'SENTO',
  'SENÃO',
  'SEPSE',
  'SEPTA',
  'SEPTO',
  'SEQUE',
  'SERAL',
  'SEREI',
  'SEREM',
  'SERES',
  'SERIA',
  'SERIÚ',
  'SERJA',
  'SERNA',
  'SERPA',
  'SERPE',
  'SERRA',
  'SERRE',
  'SERRO',
  'SERTÃ',
  'SERVA',
  'SERVE',
  'SERVI',
  'SERVO',
  'SERÁS',
  'SERÃO',
  'SESGO',
  'SESMA',
  'SESMO',
  'SESSO',
  'SESTA',
  'SESTO',
  'SETAR',
  'SETAS',
  'SETES',
  'SETIA',
  'SETOR',
  'SETOS',
  'SETRA',
  'SEVAR',
  'SEVAS',
  'SEXAR',
  'SEXOS',
  'SEXTA',
  'SEXTO',
  'SEZÃO',
  'SEÇÃO',
  'SHORT',
  'SHOWS',
  'SHUNT',
  'SICAF',
  'SICLO',
  'SIDOS',
  'SIDRA',
  'SIENA',
  'SIFÃO',
  'SIGAM',
  'SIGAS',
  'SIGLA',
  'SIGMA',
  'SIGNA',
  'SIGNO',
  'SILFO',
  'SILHA',
  'SILOS',
  'SILTE',
  'SILVA',
  'SILVE',
  'SILVO',
  'SIMBI',
  'SIMBO',
  'SIMUM',
  'SIMÃO',
  'SINAI',
  'SINAL',
  'SINAR',
  'SINAS',
  'SINDI',
  'SINDO',
  'SINGA',
  'SINHÁ',
  'SINHÔ',
  'SINOS',
  'SINTA',
  'SINTO',
  'SINÃO',
  'SIPIA',
  'SIQUE',
  'SIRGA',
  'SIRGO',
  'SIRIS',
  'SIRIÚ',
  'SIRTE',
  'SIRVA',
  'SIRVO',
  'SISAL',
  'SISAR',
  'SISMA',
  'SISME',
  'SISMO',
  'SISOS',
  'SISSÓ',
  'SISÃO',
  'SITAR',
  'SITAS',
  'SITIA',
  'SITIE',
  'SITOS',
  'SITRA',
  'SITUA',
  'SITUE',
  'SITUO',
  'SKATE',
  'SLIDE',
  'SNOBE',
  'SOADA',
  'SOADO',
  'SOAIS',
  'SOAJO',
  'SOARA',
  'SOAVA',
  'SOBEM',
  'SOBES',
  'SOBEU',
  'SOBRA',
  'SOBRE',
  'SOBRO',
  'SOCAM',
  'SOCAR',
  'SOCAS',
  'SOCOL',
  'SOCOS',
  'SOCOU',
  'SOCOÍ',
  'SOCÃO',
  'SODAR',
  'SOFRA',
  'SOFRE',
  'SOFRI',
  'SOFRO',
  'SOFÁS',
  'SOGAR',
  'SOGRA',
  'SOGRO',
  'SOILA',
  'SOITO',
  'SOJAS',
  'SOLAM',
  'SOLAR',
  'SOLAS',
  'SOLAZ',
  'SOLDA',
  'SOLDE',
  'SOLDO',
  'SOLEI',
  'SOLEM',
  'SOLES',
  'SOLFA',
  'SOLHA',
  'SOLHO',
  'SOLIA',
  'SOLOS',
  'SOLOU',
  'SOLTA',
  'SOLTE',
  'SOLTO',
  'SOLÃO',
  'SOMAI',
  'SOMAM',
  'SOMAR',
  'SOMAS',
  'SOMEI',
  'SOMEM',
  'SOMES',
  'SOMOS',
  'SOMOU',
  'SONAR',
  'SONDA',
  'SONDE',
  'SONDO',
  'SONGA',
  'SONHA',
  'SONHE',
  'SONHO',
  'SONOS',
  'SONSA',
  'SONSO',
  'SOPAS',
  'SOPLO',
  'SOPOR',
  'SOPRA',
  'SOPRE',
  'SOPRO',
  'SOPÃO',
  'SOPÉS',
  'SOQUE',
  'SORAR',
  'SORBO',
  'SORDA',
  'SORGO',
  'SORNA',
  'SOROS',
  'SORRI',
  'SORTA',
  'SORTE',
  'SORTI',
  'SORVA',
  'SORVE',
  'SORVI',
  'SORVO',
  'SOSSO',
  'SOTAS',
  'SOTOS',
  'SOUBE',
  'SOUSA',
  'SOUTO',
  'SOUZA',
  'SOVAI',
  'SOVAM',
  'SOVAR',
  'SOVAS',
  'SOVEI',
  'SOVOU',
  'SOVÉU',
  'SOÍDO',
  'SPINS',
  'SPLIT',
  'SPRAY',
  'STAFE',
  'STAFF',
  'STAND',
  'STATO',
  'STENO',
  'STOMA',
  'STOPS',
  'SUADA',
  'SUADO',
  'SUAIS',
  'SUANO',
  'SUARA',
  'SUAVA',
  'SUAVE',
  'SUAZI',
  'SUBAM',
  'SUBAS',
  'SUBIA',
  'SUBIR',
  'SUBIS',
  'SUBIU',
  'SUCAR',
  'SUCOS',
  'SUCRE',
  'SUDAR',
  'SUDRA',
  'SUECA',
  'SUECO',
  'SUEDE',
  'SUETO',
  'SUEVO',
  'SUFLÉ',
  'SUGAI',
  'SUGAM',
  'SUGAR',
  'SUGAS',
  'SUGOU',
  'SUGUE',
  'SUJAM',
  'SUJAR',
  'SUJAS',
  'SUJEI',
  'SUJEM',
  'SUJES',
  'SUJOS',
  'SUJOU',
  'SUJÃO',
  'SULCA',
  'SULCO',
  'SULFA',
  'SULFO',
  'SULIA',
  'SULÃO',
  'SUMAM',
  'SUMAS',
  'SUMIA',
  'SUMIR',
  'SUMIU',
  'SUMOS',
  'SUNGA',
  'SUNTO',
  'SUPER',
  'SUPOR',
  'SUPRA',
  'SUPRE',
  'SUPRI',
  'SUPRO',
  'SUPUS',
  'SUPÔS',
  'SUPÕE',
  'SURAL',
  'SURDA',
  'SURDO',
  'SURFA',
  'SURFE',
  'SURFO',
  'SURGE',
  'SURGI',
  'SURJA',
  'SURJO',
  'SURRA',
  'SURRE',
  'SURRO',
  'SURTA',
  'SURTE',
  'SURTO',
  'SURUÍ',
  'SURÇA',
  'SUSEP',
  'SUSHI',
  'SUSSU',
  'SUSTA',
  'SUSTE',
  'SUSTO',
  'SUTIL',
  'SUTIS',
  'SUTIÃ',
  'SUTRA',
  'SUÇÃO',
  'SUÍNA',
  'SUÍNO',
  'SUÍTE',
  'SUÍÇA',
  'SUÍÇO',
  'SUÔMI',
  'SWING',
  'SÁBIO',
  'SÁLIO',
  'SÁLIX',
  'SÁPIA',
  'SÁPIO',
  'SÁVEL',
  'SÂNDI',
  'SÂNIE',
  'SÉCIA',
  'SÉCIO',
  'SÉLIO',
  'SÉPIA',
  'SÉQUI',
  'SÉRIE',
  'SÉRIO',
  'SÉRUM',
  'SÉTER',
  'SÊMEA',
  'SÊMEN',
  'SÊMIS',
  'SÊNIO',
  'SÍCON',
  'SÍLEX',
  'SÍMEL',
  'SÍMIA',
  'SÍMIL',
  'SÍMIO',
  'SÍNUS',
  'SÍRIO',
  'SÍTIO',
  'SÓCIA',
  'SÓCIO',
  'SÓDIO',
  'SÓLEO',
  'SÓLIO',
  'SÓRIA',
  'SÓROR',
  'SÓSIA',
  'SÓTER',
  'SÓTÃO',
  'SÚBER',
  'SÚCIA',
  'SÚCIO',
  'TABAS',
  'TABES',
  'TABLA',
  'TABOA',
  'TABOR',
  'TABUS',
  'TABÃO',
  'TACAM',
  'TACAR',
  'TACHA',
  'TACHE',
  'TACHO',
  'TACOS',
  'TACOU',
  'TACÃO',
  'TAFIÁ',
  'TAFUL',
  'TAGMA',
  'TAGUÁ',
  'TAICO',
  'TAIFA',
  'TAIGA',
  'TAINA',
  'TAINO',
  'TAIPA',
  'TAIRA',
  'TAITA',
  'TALAR',
  'TALAS',
  'TALCO',
  'TALES',
  'TALHA',
  'TALHE',
  'TALHO',
  'TALIM',
  'TALMA',
  'TALOS',
  'TALÃO',
  'TAMBA',
  'TAMBI',
  'TAMBO',
  'TAMBU',
  'TAMIS',
  'TAMPA',
  'TAMPE',
  'TAMPO',
  'TAMUZ',
  'TAMÃO',
  'TANAS',
  'TANCÁ',
  'TANDO',
  'TANGA',
  'TANGE',
  'TANGI',
  'TANGO',
  'TANHO',
  'TANJA',
  'TANJO',
  'TANOA',
  'TANSO',
  'TANTA',
  'TANTO',
  'TAOCA',
  'TAPAI',
  'TAPAM',
  'TAPAR',
  'TAPAS',
  'TAPEI',
  'TAPEM',
  'TAPES',
  'TAPEÁ',
  'TAPIR',
  'TAPIZ',
  'TAPIÁ',
  'TAPOU',
  'TAPUA',
  'TAPÃO',
  'TAQUE',
  'TAQUI',
  'TARAR',
  'TARAS',
  'TARCA',
  'TARDA',
  'TARDE',
  'TARDO',
  'TARIA',
  'TARIM',
  'TARJA',
  'TAROL',
  'TAROT',
  'TARRO',
  'TARSO',
  'TARTE',
  'TARTÃ',
  'TARÃO',
  'TASCA',
  'TASCO',
  'TASTO',
  'TATAU',
  'TATEÁ',
  'TATRA',
  'TATSU',
  'TATUA',
  'TATUE',
  'TATUO',
  'TATUS',
  'TATUÍ',
  'TAURA',
  'TAURO',
  'TAVEL',
  'TAVÃO',
  'TAXAM',
  'TAXAR',
  'TAXAS',
  'TAXEI',
  'TAXEM',
  'TAXES',
  'TAXIA',
  'TAXOU',
  'TAÇAS',
  'TCHAU',
  'TEADA',
  'TEARO',
  'TEASE',
  'TEATE',
  'TEBAS',
  'TECAL',
  'TECAR',
  'TECEM',
  'TECER',
  'TECES',
  'TECEU',
  'TECIA',
  'TECLA',
  'TECLE',
  'TECLO',
  'TECNO',
  'TECTO',
  'TECUM',
  'TEDÉU',
  'TEIAS',
  'TEIGA',
  'TEIMA',
  'TEIME',
  'TEIMO',
  'TEIPE',
  'TEIRA',
  'TEIRÓ',
  'TEITÉ',
  'TEIXE',
  'TEIXO',
  'TELAR',
  'TELAS',
  'TELEM',
  'TELES',
  'TELEX',
  'TELHA',
  'TELHO',
  'TELÃO',
  'TEMAM',
  'TEMAS',
  'TEMBÉ',
  'TEMEI',
  'TEMEM',
  'TEMER',
  'TEMES',
  'TEMEU',
  'TEMIA',
  'TEMOR',
  'TEMOS',
  'TEMPE',
  'TEMPO',
  'TEMÃO',
  'TENAR',
  'TENAZ',
  'TENDA',
  'TENDE',
  'TENDI',
  'TENDO',
  'TENHA',
  'TENHO',
  'TENOR',
  'TENRA',
  'TENRO',
  'TENSA',
  'TENSE',
  'TENSO',
  'TENTA',
  'TENTE',
  'TENTO',
  'TENÇA',
  'TEPOR',
  'TEQUE',
  'TERAI',
  'TEREI',
  'TEREM',
  'TERES',
  'TEREU',
  'TERGO',
  'TERIA',
  'TERMA',
  'TERMO',
  'TERNA',
  'TERNO',
  'TEROL',
  'TERRA',
  'TERSO',
  'TERÁS',
  'TERÃO',
  'TERÇA',
  'TERÇO',
  'TESAR',
  'TESAS',
  'TESES',
  'TESLA',
  'TESOS',
  'TESSE',
  'TESTA',
  'TESTE',
  'TESTO',
  'TESÃO',
  'TETAR',
  'TETAS',
  'TETOS',
  'TETRA',
  'TETRO',
  'TETÉU',
  'TEUTO',
  'TEXTO',
  'TEÇAM',
  'TEÇAS',
  'TEÍNA',
  'TEÚDO',
  'TIANO',
  'TIARA',
  'TIBAR',
  'TIBER',
  'TIBES',
  'TICAL',
  'TICAR',
  'TICOS',
  'TICUM',
  'TIDAS',
  'TIDOS',
  'TIETA',
  'TIETE',
  'TIGRE',
  'TILHA',
  'TILHO',
  'TILIM',
  'TILOS',
  'TIMAR',
  'TIMBA',
  'TIMBU',
  'TIMBÉ',
  'TIMBÓ',
  'TIMER',
  'TIMES',
  'TIMOL',
  'TIMOR',
  'TIMÃO',
  'TINAM',
  'TINAS',
  'TINCA',
  'TINEM',
  'TINES',
  'TINGA',
  'TINGE',
  'TINGI',
  'TINHA',
  'TINHÓ',
  'TINIA',
  'TINIR',
  'TINIU',
  'TINJA',
  'TINJO',
  'TINTA',
  'TINTE',
  'TINTO',
  'TINÃO',
  'TIOTÊ',
  'TIPAS',
  'TIPIÓ',
  'TIPLE',
  'TIPOS',
  'TIPÃO',
  'TIPÓI',
  'TIQUE',
  'TIQUI',
  'TIRAI',
  'TIRAM',
  'TIRAR',
  'TIRAS',
  'TIREI',
  'TIREM',
  'TIREO',
  'TIRES',
  'TIRIÓ',
  'TIROS',
  'TIROU',
  'TIRSO',
  'TIRÃO',
  'TISCO',
  'TISNA',
  'TISNE',
  'TISSO',
  'TISSU',
  'TITIA',
  'TITIO',
  'TITÃO',
  'TITÃS',
  'TIVER',
  'TIZIO',
  'TIZIU',
  'TIÇÃO',
  'TIÚBA',
  'TMESE',
  'TOADA',
  'TOADO',
  'TOBIN',
  'TOCAI',
  'TOCAM',
  'TOCAR',
  'TOCAS',
  'TOCHA',
  'TOCOS',
  'TOCOU',
  'TODAS',
  'TODOS',
  'TOESA',
  'TOFEL',
  'TOGAR',
  'TOGAS',
  'TOIRA',
  'TOIRO',
  'TOIÇA',
  'TOIÇO',
  'TOJAL',
  'TOJOS',
  'TOLAR',
  'TOLAS',
  'TOLDA',
  'TOLDE',
  'TOLDO',
  'TOLER',
  'TOLHA',
  'TOLHE',
  'TOLHO',
  'TOLOS',
  'TOLVA',
  'TOMAI',
  'TOMAM',
  'TOMAR',
  'TOMBA',
  'TOMBE',
  'TOMBO',
  'TOMEI',
  'TOMEM',
  'TOMES',
  'TOMIA',
  'TOMOS',
  'TOMOU',
  'TOMÁS',
  'TOMÃO',
  'TONAL',
  'TONAR',
  'TONCA',
  'TONDO',
  'TONEL',
  'TONER',
  'TONGA',
  'TONGO',
  'TONHO',
  'TONIA',
  'TONTA',
  'TONTO',
  'TOPAI',
  'TOPAM',
  'TOPAR',
  'TOPAS',
  'TOPAZ',
  'TOPEI',
  'TOPEM',
  'TOPES',
  'TOPOS',
  'TOPOU',
  'TOQUE',
  'TORAL',
  'TORAR',
  'TORAS',
  'TORCE',
  'TORCI',
  'TORDA',
  'TORDO',
  'TORGA',
  'TORGO',
  'TORNA',
  'TORNE',
  'TORNO',
  'TOROS',
  'TORPE',
  'TORRA',
  'TORRE',
  'TORRO',
  'TORSO',
  'TORTA',
  'TORTO',
  'TORVO',
  'TORÃO',
  'TORÇA',
  'TORÇO',
  'TORÉM',
  'TOSAM',
  'TOSAR',
  'TOSAS',
  'TOSCA',
  'TOSCO',
  'TOSEI',
  'TOSGA',
  'TOSOU',
  'TOSSE',
  'TOSSI',
  'TOSSO',
  'TOSTA',
  'TOSTE',
  'TOSTO',
  'TOSÃO',
  'TOTAL',
  'TOTEM',
  'TOUCA',
  'TOUCO',
  'TOUPA',
  'TOURA',
  'TOURO',
  'TOXIA',
  'TRACE',
  'TRADE',
  'TRADO',
  'TRAEM',
  'TRAGA',
  'TRAGO',
  'TRAIA',
  'TRAIO',
  'TRAIR',
  'TRAIS',
  'TRAIU',
  'TRAJA',
  'TRAJE',
  'TRAJO',
  'TRAMA',
  'TRAMO',
  'TRANS',
  'TRAPA',
  'TRAPE',
  'TRAPO',
  'TRARÁ',
  'TRATA',
  'TRATE',
  'TRATO',
  'TRAVA',
  'TRAVE',
  'TRAVO',
  'TRAZE',
  'TRAÇA',
  'TRAÇO',
  'TRECO',
  'TREDO',
  'TRELA',
  'TREMA',
  'TREME',
  'TREMI',
  'TREMO',
  'TRENA',
  'TRENS',
  'TRENÓ',
  'TREPA',
  'TREPE',
  'TREPO',
  'TRETA',
  'TREVA',
  'TREVO',
  'TREZE',
  'TRIAL',
  'TRIAR',
  'TRIAS',
  'TRIBO',
  'TRICA',
  'TRICÔ',
  'TRIDI',
  'TRIGA',
  'TRIGO',
  'TRILO',
  'TRINA',
  'TRINO',
  'TRIOL',
  'TRIOS',
  'TRIPA',
  'TRIPO',
  'TRIPS',
  'TRIPÉ',
  'TRITO',
  'TROAR',
  'TROCA',
  'TROCE',
  'TROCO',
  'TROFA',
  'TROFO',
  'TROIA',
  'TROLE',
  'TRONA',
  'TRONO',
  'TROPA',
  'TROPO',
  'TROTA',
  'TROTE',
  'TROTO',
  'TROVA',
  'TRUCA',
  'TRUCO',
  'TRUDO',
  'TRUFA',
  'TRUPE',
  'TRUTA',
  'TRUÃO',
  'TUBAL',
  'TUBAR',
  'TUBAS',
  'TUBOS',
  'TUCHO',
  'TUCUM',
  'TUCÃO',
  'TUDEL',
  'TUDUM',
  'TUFAR',
  'TUFOS',
  'TUFÃO',
  'TUGIR',
  'TUIAS',
  'TUITA',
  'TULHA',
  'TUMBA',
  'TUMBO',
  'TUMOR',
  'TUNAR',
  'TUNAS',
  'TUNDA',
  'TUNDO',
  'TUNES',
  'TUNGA',
  'TUPIA',
  'TUPIS',
  'TUPLA',
  'TUPLO',
  'TUQUE',
  'TURAR',
  'TURBA',
  'TURBE',
  'TURBO',
  'TURCA',
  'TURCO',
  'TURDO',
  'TURFA',
  'TURFE',
  'TURMA',
  'TURNO',
  'TURNÊ',
  'TURRA',
  'TURVA',
  'TURVE',
  'TURVO',
  'TUSSA',
  'TUSSI',
  'TUSSO',
  'TUSTA',
  'TUSTO',
  'TUTIA',
  'TUTOR',
  'TUTTI',
  'TUTUM',
  'TUÍRA',
  'TWEED',
  'TWIST',
  'TÁBUA',
  'TÁCIA',
  'TÁLER',
  'TÁLIA',
  'TÁLIO',
  'TÁLUS',
  'TÁSIO',
  'TÁTIL',
  'TÁXIS',
  'TÁXON',
  'TÂMIA',
  'TÂMIL',
  'TÂMUL',
  'TÉDIO',
  'TÉLIO',
  'TÉRIO',
  'TÉSIS',
  'TÉTIS',
  'TÉTUM',
  'TÊNIA',
  'TÊNIS',
  'TÊNUE',
  'TÍBIA',
  'TÍBIO',
  'TÍCIO',
  'TÍLIA',
  'TÍNEA',
  'TÍNER',
  'TÍREA',
  'TÓPIA',
  'TÓRAX',
  'TÓRIA',
  'TÓRIO',
  'TÔMIO',
  'TÔNUS',
  'TÚBER',
  'TÚLIO',
  'TÚNEL',
  'TÚNIS',
  'TÚTSI',
  'UAÇAÍ',
  'UBAIA',
  'UBATÃ',
  'UBIRA',
  'UDANA',
  'UDORA',
  'UFANA',
  'UFANE',
  'UFANO',
  'UFPEL',
  'UFRGS',
  'UFRRJ',
  'UIARA',
  'UIGUR',
  'UIQUÉ',
  'UIVAI',
  'UIVAM',
  'UIVAR',
  'UIVEI',
  'UIVEM',
  'UIVOS',
  'UIVOU',
  'ULEMA',
  'ULNAR',
  'ULTRA',
  'ULULA',
  'UMARI',
  'UMBRA',
  'UMBRO',
  'UNAIS',
  'UNANI',
  'UNDOS',
  'UNEDO',
  'UNGEM',
  'UNGES',
  'UNGIA',
  'UNGIR',
  'UNGIS',
  'UNGIU',
  'UNHAR',
  'UNHAS',
  'UNHÃO',
  'UNIAM',
  'UNIAS',
  'UNIDA',
  'UNIDO',
  'UNIMO',
  'UNIRA',
  'UNITA',
  'UNIÃO',
  'UNTAM',
  'UNTAR',
  'UNTAS',
  'UNTEI',
  'UNTEM',
  'UNTOU',
  'UNÇÃO',
  'UPADO',
  'URATO',
  'URDEM',
  'URDIA',
  'URDIR',
  'URDIU',
  'UREIA',
  'URGEM',
  'URGES',
  'URGIA',
  'URGIR',
  'URGIU',
  'URINA',
  'URINE',
  'URINO',
  'URNAS',
  'URRAM',
  'URRAR',
  'URRAS',
  'URREI',
  'URROS',
  'URROU',
  'URSAS',
  'URSOS',
  'URUBU',
  'URUBÁ',
  'URUPÁ',
  'URUPÊ',
  'URUTU',
  'URUÇU',
  'URZAL',
  'URZES',
  'USADA',
  'USADO',
  'USAIS',
  'USAMO',
  'USARA',
  'USAVA',
  'USEIS',
  'USEMO',
  'USINA',
  'USTOS',
  'USUAL',
  'USURA',
  'UTENA',
  'UVADA',
  'UVAIA',
  'UVEAL',
  'UÍSTE',
  'VACAR',
  'VACAS',
  'VACUM',
  'VACUÁ',
  'VACÃO',
  'VADES',
  'VADIA',
  'VADIO',
  'VAGAL',
  'VAGAM',
  'VAGAR',
  'VAGAS',
  'VAGEM',
  'VAGIA',
  'VAGOS',
  'VAGOU',
  'VAGUE',
  'VAGÃO',
  'VAIAM',
  'VAIAR',
  'VAIAS',
  'VAIEI',
  'VAIEM',
  'VAILA',
  'VAIOU',
  'VAIPE',
  'VAIRA',
  'VAIXÁ',
  'VALAR',
  'VALAS',
  'VALDO',
  'VALEI',
  'VALEM',
  'VALER',
  'VALES',
  'VALEU',
  'VALGO',
  'VALHA',
  'VALHO',
  'VALIA',
  'VALOR',
  'VALOS',
  'VALSA',
  'VALVA',
  'VALÃO',
  'VAMOS',
  'VAMPE',
  'VAMPI',
  'VANDA',
  'VANGA',
  'VANTE',
  'VAPOR',
  'VARAL',
  'VARAM',
  'VARAR',
  'VARAS',
  'VAREI',
  'VAREM',
  'VARES',
  'VARGA',
  'VARGE',
  'VARIA',
  'VARIE',
  'VARIO',
  'VARIZ',
  'VAROA',
  'VAROU',
  'VARRA',
  'VARRE',
  'VARRI',
  'VARRO',
  'VARÃO',
  'VASCA',
  'VASCO',
  'VASOS',
  'VASSÁ',
  'VASTA',
  'VASTO',
  'VATEL',
  'VAZAM',
  'VAZAR',
  'VAZAS',
  'VAZEI',
  'VAZEM',
  'VAZES',
  'VAZIA',
  'VAZIO',
  'VAZOU',
  'VAZÃO',
  'VEADA',
  'VEADO',
  'VEDAM',
  'VEDAR',
  'VEDAS',
  'VEDEI',
  'VEDEM',
  'VEDES',
  'VEDOR',
  'VEDOU',
  'VEDRO',
  'VEIAS',
  'VEIGA',
  'VEIOS',
  'VEIRO',
  'VEJAM',
  'VEJAS',
  'VELAI',
  'VELAM',
  'VELAR',
  'VELAS',
  'VELEI',
  'VELEM',
  'VELES',
  'VELHA',
  'VELHO',
  'VELOS',
  'VELOU',
  'VELOZ',
  'VELTA',
  'VEMOS',
  'VENAL',
  'VENCE',
  'VENCI',
  'VENDA',
  'VENDE',
  'VENDI',
  'VENDO',
  'VENHA',
  'VENHO',
  'VENTA',
  'VENTE',
  'VENTO',
  'VENÇA',
  'VENÇO',
  'VERAS',
  'VERAZ',
  'VERBA',
  'VERBO',
  'VERDE',
  'VEREI',
  'VEREM',
  'VERES',
  'VERGA',
  'VERGÊ',
  'VERIA',
  'VERIL',
  'VERME',
  'VERNA',
  'VERNO',
  'VERSA',
  'VERSE',
  'VERSO',
  'VERTA',
  'VERTE',
  'VERTI',
  'VERTO',
  'VERVE',
  'VERÃO',
  'VERÇA',
  'VESCO',
  'VESGA',
  'VESGO',
  'VESPA',
  'VESSO',
  'VESTE',
  'VESTI',
  'VETAM',
  'VETAR',
  'VETAS',
  'VETEI',
  'VETEM',
  'VETES',
  'VETOR',
  'VETOS',
  'VETOU',
  'VEXAM',
  'VEXAR',
  'VEXAS',
  'VEXES',
  'VEXOU',
  'VEZES',
  'VIADO',
  'VIAJA',
  'VIAJE',
  'VIAJO',
  'VIANA',
  'VIARA',
  'VIBRA',
  'VIBRE',
  'VIBRO',
  'VICHI',
  'VICIA',
  'VICIE',
  'VICTO',
  'VIDAR',
  'VIDAS',
  'VIDES',
  'VIDRA',
  'VIDRO',
  'VIELA',
  'VIERA',
  'VIGAR',
  'VIGAS',
  'VIGER',
  'VIGIA',
  'VIGIE',
  'VIGIO',
  'VIGNA',
  'VIGOR',
  'VIIIA',
  'VILAR',
  'VILAS',
  'VILOA',
  'VILTA',
  'VILÃO',
  'VIMAR',
  'VIMOS',
  'VINAL',
  'VINCA',
  'VINCO',
  'VINDA',
  'VINDE',
  'VINDO',
  'VINGA',
  'VINGO',
  'VINHA',
  'VINHO',
  'VINIL',
  'VINTE',
  'VIOLA',
  'VIOLE',
  'VIOLO',
  'VIRAI',
  'VIRAL',
  'VIRAM',
  'VIRAR',
  'VIRAS',
  'VIREI',
  'VIREM',
  'VIRES',
  'VIRGA',
  'VIRGO',
  'VIRIA',
  'VIRIL',
  'VIRIS',
  'VIROL',
  'VIROU',
  'VIRÃO',
  'VISAM',
  'VISAR',
  'VISAS',
  'VISCO',
  'VISEI',
  'VISEM',
  'VISES',
  'VISGO',
  'VISOM',
  'VISOR',
  'VISOS',
  'VISOU',
  'VISSE',
  'VISTA',
  'VISTE',
  'VISTO',
  'VISÃO',
  'VITAE',
  'VITAL',
  'VITRE',
  'VITRO',
  'VIVAM',
  'VIVAR',
  'VIVAS',
  'VIVAZ',
  'VIVEI',
  'VIVEM',
  'VIVER',
  'VIVES',
  'VIVEU',
  'VIVIA',
  'VIVIÚ',
  'VIVOS',
  'VIZIR',
  'VIÇAR',
  'VIÚVA',
  'VIÚVO',
  'VOADO',
  'VOAIS',
  'VOARA',
  'VOAVA',
  'VOCAL',
  'VOCÊS',
  'VODCA',
  'VODUM',
  'VOGAL',
  'VOGAR',
  'VOGAS',
  'VOGUE',
  'VOILE',
  'VOLAR',
  'VOLTA',
  'VOLTE',
  'VOLTO',
  'VOLTS',
  'VOLVA',
  'VOLVE',
  'VOLVI',
  'VOLVO',
  'VONDA',
  'VORAZ',
  'VOSSA',
  'VOSSO',
  'VOTAI',
  'VOTAM',
  'VOTAR',
  'VOTAS',
  'VOTEI',
  'VOTEM',
  'VOTES',
  'VOTOS',
  'VOTOU',
  'VOVÓS',
  'VOZES',
  'VOZÃO',
  'VREIA',
  'VULCO',
  'VULGO',
  'VULSO',
  'VULTO',
  'VULVA',
  'VÁCUO',
  'VÁLEA',
  'VÁLIO',
  'VÁTUA',
  'VÉLIA',
  'VÉLUM',
  'VÉRIO',
  'VÊNIA',
  'VÊNUS',
  'VÍCIO',
  'VÍDEO',
  'VÍDIA',
  'VÍEIS',
  'VÍGIL',
  'VÍRUS',
  'VÍTIS',
  'VÔLEI',
  'VÔMER',
  'WATTS',
  'WEBER',
  'XADOR',
  'XAILE',
  'XALES',
  'XAMBÁ',
  'XAMPU',
  'XAMÃS',
  'XANGÓ',
  'XANTO',
  'XAQUE',
  'XARIA',
  'XARÁS',
  'XARÉM',
  'XARÉU',
  'XAXIM',
  'XCIII',
  'XCVII',
  'XELIM',
  'XENOS',
  'XEQUE',
  'XEREU',
  'XEREZ',
  'XERGA',
  'XEROX',
  'XERÉM',
  'XEXÉU',
  'XIBIO',
  'XIBIU',
  'XIITA',
  'XILOL',
  'XIMBO',
  'XINGA',
  'XINGO',
  'XINTÓ',
  'XIRUA',
  'XISTO',
  'XLIII',
  'XLVII',
  'XOGUM',
  'XONAR',
  'XUCRA',
  'XUCRO',
  'XVIII',
  'XXIII',
  'XXVII',
  'XXXII',
  'XXXIV',
  'XXXIX',
  'XXXVI',
  'XÉNON',
  'XÊNIA',
  'XÊNIO',
  'ZACAÍ',
  'ZAGAL',
  'ZAGAS',
  'ZAGOR',
  'ZAIDA',
  'ZAIDI',
  'ZAINE',
  'ZAINO',
  'ZAIRA',
  'ZAIRE',
  'ZAMBA',
  'ZAMBI',
  'ZAMBO',
  'ZAMBÊ',
  'ZANDE',
  'ZANGA',
  'ZANGO',
  'ZANTE',
  'ZANZA',
  'ZARCO',
  'ZARPA',
  'ZARPE',
  'ZARPO',
  'ZARRA',
  'ZARRO',
  'ZARZA',
  'ZEBRA',
  'ZEBRO',
  'ZEFIR',
  'ZELAI',
  'ZELAM',
  'ZELAR',
  'ZELAS',
  'ZELEI',
  'ZELEM',
  'ZELOS',
  'ZELOU',
  'ZENDA',
  'ZENDE',
  'ZENIR',
  'ZERAM',
  'ZERAR',
  'ZERAS',
  'ZERBO',
  'ZEREI',
  'ZEREM',
  'ZERES',
  'ZEROS',
  'ZEROU',
  'ZESTO',
  'ZIMBO',
  'ZINCO',
  'ZINGA',
  'ZINHO',
  'ZIPAR',
  'ZOADA',
  'ZOADO',
  'ZOARA',
  'ZOAVA',
  'ZOIDE',
  'ZOILO',
  'ZOINA',
  'ZOMBA',
  'ZOMBE',
  'ZOMBO',
  'ZONAL',
  'ZONAR',
  'ZONAS',
  'ZONES',
  'ZONZA',
  'ZONZO',
  'ZORRA',
  'ZORRO',
  'ZUAVO',
  'ZULUS',
  'ZUMBA',
  'ZUMBE',
  'ZUMBI',
  'ZUMBO',
  'ZUNEM',
  'ZUNGA',
  'ZUNGU',
  'ZUNIA',
  'ZUNIR',
  'ZUNIU',
  'ZURRA',
  'ZURRO',
  'ZÍNIA',
  'ZÍPER',
  'ÀBEÇA',
  'ÁBACO',
  'ÁBIES',
  'ÁBIGA',
  'ÁCADE',
  'ÁCANO',
  'ÁCARE',
  'ÁCARO',
  'ÁCIDA',
  'ÁCIDO',
  'ÁCINO',
  'ÁCLIS',
  'ÁCOPE',
  'ÁCORO',
  'ÁCRON',
  'ÁCTIO',
  'ÁDINE',
  'ÁDIPE',
  'ÁDIPO',
  'ÁGAPA',
  'ÁGAPE',
  'ÁGARO',
  'ÁGATA',
  'ÁGATE',
  'ÁGEIS',
  'ÁGENO',
  'ÁGIDA',
  'ÁGIOS',
  'ÁGONO',
  'ÁGRIA',
  'ÁGRIO',
  'ÁGUAM',
  'ÁGUAS',
  'ÁGUIA',
  'ÁLAMO',
  'ÁLBUM',
  'ÁLCEA',
  'ÁLEMO',
  'ÁLIBA',
  'ÁLIBI',
  'ÁLICA',
  'ÁLIFE',
  'ÁLOGO',
  'ÁLULA',
  'ÁLVEO',
  'ÁPETO',
  'ÁPICE',
  'ÁPIDA',
  'ÁPIRA',
  'ÁPIRO',
  'ÁPOCA',
  'ÁPODE',
  'ÁPONE',
  'ÁPORO',
  'ÁPULO',
  'ÁQUEO',
  'ÁRABE',
  'ÁRABO',
  'ÁRCIO',
  'ÁRDEA',
  'ÁRDUA',
  'ÁRDUO',
  'ÁREAS',
  'ÁRGON',
  'ÁRIAS',
  'ÁRIDA',
  'ÁRIDO',
  'ÁRIES',
  'ÁRSIS',
  'ÁSARO',
  'ÁSCON',
  'ÁSCUA',
  'ÁSPIS',
  'ÁSTER',
  'ÁSTUR',
  'ÁTILA',
  'ÁTIMO',
  'ÁTOMO',
  'ÁTONA',
  'ÁTONO',
  'ÁTRIO',
  'ÁUDIO',
  'ÁUREA',
  'ÁUREO',
  'ÁVIDA',
  'ÁVIDO',
  'ÁVILA',
  'ÁXILO',
  'ÁZIGO',
  'ÁZIMO',
  'ÂMAGO',
  'ÂMBAR',
  'ÂMNIO',
  'ÂNIMO',
  'ÂNION',
  'ÂNODO',
  'ÂNSIA',
  'ÉBANO',
  'ÉBRIO',
  'ÉCANO',
  'ÉCOPE',
  'ÉCRAN',
  'ÉCULO',
  'ÉDICO',
  'ÉDIPO',
  'ÉFETA',
  'ÉFODE',
  'ÉFORO',
  'ÉGIDE',
  'ÉGUAS',
  'ÉGUEM',
  'ÉLICO',
  'ÉNULA',
  'ÉPICA',
  'ÉPICO',
  'ÉPOCA',
  'ÉPURA',
  'ÉQUIO',
  'ÉQUIS',
  'ÉRBIO',
  'ÉREBO',
  'ÉREIS',
  'ÉRGIO',
  'ÉRICA',
  'ÉRICO',
  'ÉRINA',
  'ÉSIMA',
  'ÉSIMO',
  'ÉTICA',
  'ÉTICO',
  'ÉTIMO',
  'ÊIDER',
  'ÊMESE',
  'ÊMICO',
  'ÊMULO',
  'ÊXITO',
  'ÊXODO',
  'ÍAMOS',
  'ÍCARO',
  'ÍCONE',
  'ÍCONO',
  'ÍCORE',
  'ÍCTIS',
  'ÍCTUS',
  'ÍDOLA',
  'ÍDOLO',
  'ÍGNEA',
  'ÍGNEO',
  'ÍLEON',
  'ÍLION',
  'ÍLIUM',
  'ÍMPAR',
  'ÍMPIA',
  'ÍMPIO',
  'ÍNDIO',
  'ÍNDRI',
  'ÍNGUA',
  'ÍNSUA',
  'ÍNVIO',
  'ÍTACA',
  'ÍTALO',
  'ÍTRIA',
  'ÍTRIO',
  'ÓBELO',
  'ÓBICE',
  'ÓBITO',
  'ÓBOLO',
  'ÓBULO',
  'ÓBVIA',
  'ÓBVIO',
  'ÓCULO',
  'ÓDIOS',
  'ÓFRIO',
  'ÓLEOS',
  'ÓPIDO',
  'ÓRFÃO',
  'ÓRFÃS',
  'ÓRGÃO',
  'ÓSMIO',
  'ÓSSEA',
  'ÓSSEO',
  'ÓSTIO',
  'ÓTICA',
  'ÓTICO',
  'ÓTIMA',
  'ÓTIMO',
  'ÓVALO',
  'ÓVULO',
  'ÓXIDO',
  'ÔMEGA',
  'ÚBERE',
  'ÚMERO',
  'ÚMIDA',
  'ÚMIDO',
  'ÚNCIA',
  'ÚNCUS',
  'ÚNICA',
  'ÚNICO',
  'ÚRACO',
  'ÚRANO',
  'ÚRICO',
  'ÚTEIS',
  'ÚTERO',
  'ÚVIDO',
  'ÚVULA',
]